import { React, useEffect, useState } from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import upgrade from "../../../Assets/Icons/up-range.svg";
import downgrade from "../../../Assets/Icons/down-range.svg";
import {
  RightLayoutContainer,
  PageTitleComp,
  DetailFields,
  ResultWrap,
  TableLayoutData,
  PipeDesign,
  ContentMiddle,
} from "../../styledElements";
import JobcardPrepare from "../../../Components/IconsFiles/preparing_job_card";
import {
  Button,
  PageHeader,
  Tabs,
  Row,
  Col,
  Table,
  Tooltip,
  Radio,
  Input,
  Form,
  Skeleton,
} from "antd";
import { Styled, RadioButtonStyle } from "../../pageStyled";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertBlue from "../../../Assets/Icons/alertBlue.svg";
import Iconmoon from "../../../Components/IconsFiles/icon";
import {
  approveRejectJobCard,
  createNewDuplexSolution,
  createNewSheetSolution,
  getAlgorithmCompletionStatus,
  getFailedGroups,
  getJobCardCylinders,
  getJobCardsById,
  getJobCardsDetails,
} from "../../../Services/deckleMatchServices";
import { getOrdersList, getPosData } from "../../../Services/orderServices";
import moment from "moment";
import { TableList, JobCardColorStatus } from "../../pageStyled";
import { HaberForm } from "../../styledElements";
import JobCardCylinderContainer from "../../../Components/JobCardCylinders/JobCardCylinderContainer";
import warning from "../../../Assets/Icons/warning.png";
import { ModalPopup } from "../../../Components/Modal/modal";
import ConfirmationModal from "../../../Components/Modal/ConfirmationModal";
import JobCardRejectDrawer from "./JobCardRejectDrawer/JobCardRejectDrawer";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import { getStocksDetailsByIds } from "../../../Services/productServices";
import ViewDeckleOrder from "../DeckleOrderDrawer/viewDeckleOrder";
import SheetJobCardCylinderContainer from "../../../Components/JobCardCylinders/SheetJobCardCylinderContainer";
import {
  changeProductionJobCardState,
  getJumboReelDetailsById,
  replanJobcard,
} from "../../../Services/productionPlanningServices";
import ClosedProductionDrawer from "../../ProductionPlanning/ProductionJobCards/JobcardDrawers/closedProductionDrawer";
import MapToJumboDrawer from "../../ProductionPlanning/ProductionJobCards/JobcardDrawers/mapToJumboDrawer";
import CancelJobCardDrawer from "../../ProductionPlanning/ProductionJobCards/JobcardDrawers/cancelJobCardDrawer";
import CancelProductionDrawer from "../../ProductionPlanning/ProductionJobCards/JobcardDrawers/cancelProductionDrawer";
import Mapping from "../../../Assets/Icons/maping.svg";
import MappingEdit from "../../../Assets/Icons/maping-edit.svg";
import CloseProduction from "../../../Assets/Icons/close-production.svg";
import PrintIcon from "../../../Assets/Icons/printer2.svg";
import ParentReelJobCardDrawer from "../../ProductionPlanning/ProductionJobCards/JobcardDrawers/parentReelJobCardDrawer";
import DuplexJobCardCylinderContainer from "../../../Components/JobCardCylinders/DuplexJobCardCylinderContainer";
import {
  lengthUnit,
  weightUnit,
  currency_List,
  CoversionFactorUnitsToCM,
  CoversionFactorCMToUnits,
} from "../../../Utils/Constant/MeasurementUnitList.jsx";
import { getUnitData } from "../../../Services/measurementService";
import emptyState_NoData from "../../../Assets/Images/emptyState_NoData.svg";
import styled from "styled-components";
import TableShimmer from "../../../Components/TableShimmer/tableShimmer.jsx";
import { toHandlePOName } from "../../../Utils/helper/helper.js";
import LottieAnimation from "../../../Lottie.js";
import CreateNewSheetSolution from "../DeckleResults/createNewSheetSolution.jsx";
import { getWorkflowSettings } from "../../../Services/workFlowSettingsServices.js";

const CardShimmerStyle = styled.div`
  .ant-card-body {
    position: relative;
    z-index: 0;
    overflow: hidden;
    height: 100%;
    padding: 0px;
  }
  .ant-skeleton-element .ant-skeleton-button {
    min-width: 0px;
    width: 100%;
    border-radius: 3px;
  }
  .ant-skeleton-element .ant-skeleton-input {
    min-width: 0px;
    width: 100%;
    border-radius: 3px;
  }
  .ant-skeleton-element {
    width: 100%;
  }
`;

const capitalize = (item) => item.charAt(0).toUpperCase() + item.slice(1);

const Panes = Tabs.TabPane;

const gridViewData = [
  {
    label: <Iconmoon icon="grid-chart" size={20} color="#EA655B" />,
    value: "grid",
  },
  { label: <Iconmoon icon="table" size={20} color="#EA655B" />, value: "list" },
];

// function onChange(pagination, filters, sorter, extra) {
//   console.log("params", pagination, filters, sorter, extra);
// }

const SheetJobCardDetailData = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  let [searchParams, setSearchParams] = useSearchParams();
  const [ordersFullFilledList, setOrdersFullFilledList] = useState([]);
  const [ordersUnFullFilledList, setOrdersUnFullFilledList] = useState([]);
  // const [posList, setPosList] = useState([]);
  const type = location.state ? location.state.tyoe : searchParams.get("type");
  const cutter_type = location.state
    ? location.state.cutter_type
    : searchParams.get("cutter_type");
  const [jobId, setJobId] = useState(
    location.state ? location.state.id : searchParams.get("id")
  );
  const [jobCard, setJobCard] = useState();
  const [jobcardCode, setJobcardcode] = useState();
  const [jobcardType, setJobCardType] = useState(
    location.state ? location.state.jobcardType : ""
  );
  const [acceptedSolution, setAcceptedSolution] = useState({
    name: null,
    key: null,
    solution: null,
  });
  // const [cylinderData, setCylinderData] = useState();
  //List view state
  // const [gridView, setGridView] = useState(true);
  // const [cylinderColumnHead, setCylinderColumnHead] = useState([]);
  // const [loadingColumnHead, setLoadingColumnHead] = useState(true);
  const [solutionId, setSolutionId] = useState("1");
  //List view state ends here
  const [isVisibleApproveModal, setIsVisibleApproveModal] = useState(false);
  const [visibleRejectDrawer, setVisibleRejectDrawer] = useState(false);
  const [visibleMarkCompletedModal, setVisibleMarkCompletedModal] =
    useState(false);
  const [visibleCancelProduction, setVisibleCancelProduction] = useState(false);
  const [visibleStartProduction, setVisibleStartProduction] = useState(false);
  const [actionResponse, setActionResponse] = useState({});
  const [reFetch, setReFetch] = useState(true);
  const [toaster, setToaster] = useState(false);
  const [viewOrder, setViewOrder] = useState(false);
  const [orderDetailsList, setOrderDetailsList] = useState();
  const [selectedOrderNo, setSelectedOrderNo] = useState();
  const [selectedOrder, setSelectedOrder] = useState();

  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("user-details"))
  );
  const [settingsData, setSettingsData] = useState(
    JSON.parse(localStorage.getItem("setting-data"))
  );
  const [sizeFulfillmentDetailsList, setSizeFulfillmentDetailsList] =
    useState();
  const [visible, setVisible] = useState(false);
  const [visibleHold, setVisibleHold] = useState(false);
  const [viewCancelJobCardDrawer, setViewCancelJobCardDrawer] = useState(false);
  const [viewParentReelJobCardDrawer, setViewParentReelJobCardDrawer] =
    useState(false);
  const [viewCloseProductionDrawer, setViewCloseProductionDrawer] =
    useState(false);
  const [viewMapToReelDrawer, setViewMapToReelDrawer] = useState(false);
  const [viewCancelProductionDrawer, setViewCancelProductionDrawer] =
    useState(false);
  const [producedParentReelBool, setProducedParentReelBool] = useState(false);
  const [selectedParentReel, setSelectedParentReel] = useState();
  const [disableCancel, setDisableCancel] = useState(false);
  const [reFetchJumboReels, setReFetchJumboReels] = useState(true);
  const [jumboReelData, setJumboReelData] = useState();
  const history = useNavigate();
  const [activeTab, setActiveTab] = useState("1");
  const [disablePrint, setDisablePrint] = useState(true);
  const [unitData, setUnitData] = useState();
  const [actionType, setActionType] = useState(
    location.state ? location.state.type : ""
  );
  const [sizeExpanded, setSizeExpanded] = useState(false);
  const [isReplanClicked, setIsReplanClicked] = useState(false);
  const [isCreateNewSolutionClicked, setIsCreateNewSolutionClicked] =
    useState(false);
  const [formValuesForStock, setFormValuesForStock] = useState({});
  const [jobIndex, setJobIndex] = useState(0);
  const [createNewSolutionClicked, setCreateNewSolutionClicked] = useState({
    isClicked: false,
    index: -1,
  });
  const [jobCardDetailsList, setJobCardDetailsList] = useState([]);
  const [rerendering, setRerendering] = useState(false);
  const [solId, setSolId] = useState("1");
  const [showAimation, setShowAimation] = useState({});
  const [
    createNewSolutionFormValuesForSizes,
    setCreateNewSolutionFormValuesForSizes,
  ] = useState();
  const [stockSizes, setStockSizes] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [orderManagementSettings,setOrderManagementSettings] = useState(JSON.parse(localStorage.getItem("order-management-settings")));

  const columnBlacklist =
    settingsData?.settings?.orders_page?.tables?.jobcard_orders || [];
  const format = settingsData?.settings?.product_spec?.format || "";
  // const [sizeExpanded, setSizeExpanded] = useState(false);
  // const [sizeExpanded, setSizeExpanded] = useState(false);
  const [dynamicStock, setDynamicStock] = useState([]);

  const onPaginationChange = (page, pageSize, isUnfulfilled) => {
    // console.log(page, pageSize);
    setCurrentPage(page);
    setPageSize(pageSize);
    // isUnfulfilled && setIsUnfulfilledTab(true);
  };

  function onChange(pagination, filters, sorter, extra) {
    // console.log("params", pagination, filters, sorter, extra);
    if (pagination) onPaginationChange(pagination.current, pagination.pageSize);
  }

  const printJobCardDetails = () => {
    if (cutter_type == "simplex")
      navigate(location?.pathname?.includes("production")?"./print":"../job-card-details/viewer", {
        state: {
          jobId: jobId,
          jobcardCode: getJCCode(jobCard.jobcard_code),
          solution: acceptedSolution.key,
          orderDetailsList,
          acceptedSolution: acceptedSolution,
          jobCard: jobCard.jobcard,
          cutter_type: cutter_type,
          type: "singleStage",
          machine_type: "cutter",
        },
      });
    else
      navigate(location?.pathname?.includes("production")?"./duplex-print":"../job-card-details/viewer", {
        state: {
          jobId: jobId,
          jobcardCode: getJCCode(jobCard.jobcard_code),
          solution: acceptedSolution.key,
          orderDetailsList,
          acceptedSolution: acceptedSolution,
          jobCard: jobCard.jobcard,
          cutter_type: cutter_type,
          type: "singleStage",
          machine_type: "cutter",
        },
      });
  };

  const getJCCode = (str) => {
    if (str) {
      let splittedString = str?.split("~");
      let mergeString;
      mergeString = splittedString?.join("");
      return mergeString;
    }
  };

  const approveJobCard = (jobId) => {
    approveRejectJobCard({ id: jobId, state: "approved" })
      .then((response) => {
        setActionResponse({ error: response.error, msg: response.msg });
        setReFetch(true);
      })
      .catch((error) => {
        setActionResponse({
          error: error.response.data.error,
          msg: error.response.data.msg,
        });
        console.log(error);
      });
  };

  const tabChange = (key) => setActiveTab(key);

  const showToaster = () => {
    setToaster(true);
    setTimeout(() => setToaster(false), 3000);
  };

  const approveModalShow = () => {
    setIsVisibleApproveModal(true);
  };

  const approveModalClose = () => {
    setIsVisibleApproveModal(false);
  };

  const approveModalConfirm = (value) => {
    approveJobCard(value);
    setIsVisibleApproveModal(false);
    setReFetch(true);
    showToaster();
  };

  const showMapToReel = (id, action) => {
    setSelectedParentReel(id);
    setViewMapToReelDrawer(true);
    setActionType(action);
  };

  const showRejectDrawer = () => {
    setVisibleRejectDrawer(true);
  };

  const closeRejectDrawer = () => {
    setVisibleRejectDrawer(false);
  };

  const showViewDrawer = (value, record) => {
    setSelectedOrderNo(value);
    setSelectedOrder(record);
    setViewOrder(true);
  };

  const closeViewDrawer = () => {
    setViewOrder(false);
  };

  const showModal = () => {
    setVisible(true);
  };

  const closeModal = () => {
    setVisible(false);
  };

  const modalConfirm = () => {
    resumeProduction();
    setVisible(false);
  };

  const showParentReelJobCard = (id) => {
    setSelectedParentReel(id);
    setViewParentReelJobCardDrawer(true);
  };

  const capitalize = (item) => item.charAt(0).toUpperCase() + item.slice(1);

  //A switch case function to return states of a job card.
  const jobcardState = (state) => {
    switch (state) {
      case "pending":
        return "Pending for approval";
      case "approved":
        return "Approved";
      case "rejected":
        return "Rejected";
      case "in_production":
        return "In Production";
      case "cancel":
        return "Cancelled";
      case "complete":
        return "Complete";
      case "hold":
        return "On Hold";
      case "produced":
        return "Produced";
      case "active":
        return "Active";
      case "under_review":
        return "Under Review";
      case "cancelled":
        return "Cancelled";
      default:
        return;
    }
  };
  //api-call to get the details of a specific jobcard
  const getJobCardDetailsById = async () => {
    try {
      const response = await getJobCardsById(jobId);
      if (response?.jobcard_code) {
        let splittedString = response?.jobcard_code?.split("~");
        setJobcardcode(splittedString?.join(""));
      }
      setJobCard(response);
      setJobCardType(response.type);
      if (response?.jobcard.solution_1.status == "accept") {
        // console.log("acc1", acceptedSolution);
        setAcceptedSolution({
          name: "Solution 1",
          key: 1,
          solution: response.jobcard.solution_1.data,
        });
        setSizeFulfillmentDetails(response.jobcard.solution_1.data.sizes);
      } else if (response?.jobcard.solution_2.status == "accept") {
        // console.log("acc2", acceptedSolution);
        setAcceptedSolution({
          name: "Solution 2",
          key: 2,
          solution: response.jobcard.solution_2.data,
        });
        setSizeFulfillmentDetails(response.jobcard.solution_2.data.sizes);
      }
    } catch (error) {
      console.log("Error in accepting solution", error.response);
    }
  };

  const setSizeFulfillmentDetails = (sizes) => {
    let sizeFulfillmentListArr;
    sizeFulfillmentListArr = sizes.filter((item) => item?.fulfilled_weight > 0);
    let sizeFulfillmentList = sizeFulfillmentListArr?.map((size, index) => {
      return {
        key: index + 1,
        type: "Order",
        size: `${size.breadth} X ${size.length} ${
          size?.units && size.units?.length
            ? lengthUnit[size.units?.length].displayName.toUpperCase()
            : "CM"
        }`,
        plannedReels: size.sheet_requirement,
        plannedWeight:
          size.weight_requirement.toFixed(3) +
          " " +
          (size?.units && size.units?.weight_requirement
            ? capitalize(weightUnit[size.units?.weight_requirement].displayName)
            : "T"),
        fulflilledReels: size.fulfilled_sheet,
        fulflilledWeight:
          size.fulfilled_weight.toFixed(3) +
          " " +
          (size?.units && size.units?.fulfilled_weight
            ? capitalize(weightUnit[size.units?.fulfilled_weight].displayName)
            : "T"),
        unFulflilledReels: size.unfulfilled_sheet,
        unFulflilledWeight:
          size.unfulfilled_weight.toFixed(3) +
          " " +
          (size?.units && size.units?.unfulfilled_weight
            ? capitalize(weightUnit[size.units.unfulfilled_weight].displayName)
            : "T"),
        priority: size.priority,
      };
    });
    setSizeFulfillmentDetailsList(sizeFulfillmentList);
  };

  const fetchOrders = async () => {
    let orderList = [];
    const ordersList = acceptedSolution.solution.orders
      ?.filter((order) => {
        return order.type.toLowerCase() == "order";
      })
      .map((item) => item.order_id);
    ordersList &&
      (await getOrdersList(ordersList)
        .then((response) => {
          orderList = response.data.map((item, index) => {
            const orderData = acceptedSolution.solution.orders.filter(
              (order) => order.order_id == item.number
            )[0];
            return {
              key: index + 1,
              pono: `${item.po}`,
              category: item?.category,
              sono: item?.so,
              overfulfillmentPercentage: `${(((orderData.fulfilled_rquirement/orderData.requirement)-1)* 100).toFixed(2)}%`,
              orderno: `${item.number}`,
              type: "Order",
              grain: item.grain == "short" ? "Short" : "Long",
              productspec: item.product_spec,
              customercode: item.customer,
              customername: item.customer_name,
              customer_alias: item.customer_alias,
              size: `${item.width}${item.length ? ` x ${item.length}` : ""} ${
                item?.units && item.units?.width
                  ? lengthUnit[item.units.width].displayName.toUpperCase()
                  : "CM"
              }`,
              length: item.length,
              width: item.width,
              productInfo: item.product_info,
              orderWeight: `${item?.weight?.toFixed(3)} ${item?.units?.weight?.toUpperCase()}`,
              plannedReels: orderData.requirement,
              plannedWeight:
                orderData.requirement_weight.toFixed(3) +
                " " +
                (orderData?.units && orderData.units?.requirement_weight
                  ? capitalize(
                      weightUnit[orderData.units.requirement_weight].displayName
                    )
                  : "T"),
              fulflilledReels: orderData.fulfilled_rquirement,
              fulflilledWeight:
                orderData.fulfilled_rquirement_weight.toFixed(3) +
                " " +
                (orderData?.units &&
                orderData.units?.fulfilled_rquirement_weight
                  ? capitalize(
                      weightUnit[orderData.units?.fulfilled_rquirement_weight]
                        .displayName
                    )
                  : "T"),
              unFulflilledReels: orderData.unfulfilled_rquirement,
              unFulflilledWeight:
                orderData.unfulfilled_rquirement_weight.toFixed(3) +
                " " +
                (orderData.units &&
                orderData.units?.unfulfilled_rquirement_weight
                  ? capitalize(
                      weightUnit[orderData.units?.unfulfilled_rquirement_weight]
                        .displayName
                    )
                  : "T"),
              priority: item.forced,
              //  jobCard.jobcard.group.orders.filter(
              //   (order) => order.order_id == item.number
              // )[0].forced,
              deliverydate:
                item.category === "so"
                  ? "-"
                  : moment(item.delivery_date).format("DD MMM YYYY"),
              remarks: item.remarks,
              grain: item.grain == "short" ? "Short" : "Long",
              no_of_sheets: item.no_of_sheets,
              units: item.units,
              consignee_name: item.consignee_name,
              consignee_code: item.consignee,
              fWeight: orderData.fulfilled_rquirement_weight,
              fWeightUnit:
                orderData?.units && orderData.units?.requirement_weight
                  ? capitalize(
                      weightUnit[orderData.units.requirement_weight].displayName
                    )
                  : "T",
              external_order_id: item.external_order_id,
              remarks: item.remarks
            };
          });
          const stockSizesList = acceptedSolution.solution.orders
            ?.filter((order) => {
              return order.type.toLowerCase() == "stock";
            })
            .map((item) => item.order_id);
          const dynamicStock = acceptedSolution.solution.orders
            ?.filter((order) => {
              return (
                order.item_type == "stock" &&
                (order.creation_type === "dynamic" ||
                  order.creation_type === "required")
              );
            })
            .map((item) => {
              return {
                allowedQuantity: item?.requirement,
                availableLimit: item?.requirement,
                length: item?.length,
                width: item?.breadth,
                stockSize:
                  item.type === "reel"
                    ? +item.breadth
                    : +item.breadth +
                      " " +
                      lengthUnit[item.units.breadth].displayName.toUpperCase() +
                      " * " +
                      +item.length +
                      " " +
                      lengthUnit[item.units.length].displayName.toUpperCase(),
                isSelected: true,
                ...(item.creation_type === "dynamic" && { isNew: true }),
                ...(item.creation_type === "required" && {
                  isRequired: true,
                  weight_lb: item?.weight_lb,
                  weight_ub: item?.weight_ub,
                  priority_stock: item.priority_stock,
                }),
                isEdit: false,
                isGrainChanged: item.rotated ? item.rotated : false,
                grain: item.grain,
                units: {
                  ...item.units,
                  quantity: item?.units?.requirement_weight,
                  width: item?.units?.width,
                  length: item?.units?.length,
                  weight_lb: item?.units?.weight_lb,
                  weight_ub: item?.units?.weight_ub,
                },
              };
            });
          setDynamicStock(dynamicStock);
          if (stockSizesList.length > 0) {
            getStocksDetailsByIds({ stocks: stockSizesList })
              .then((response) => {
                let sizesList = response.data.map((item, index) => {
                  const orderData = acceptedSolution.solution.orders.filter(
                    (order) => order.order_id == item.id
                  )[0];
                  //console.log(orderData);
                  return {
                    key: index + 1,
                    pono: "-",
                    orderno: `${item.id}`,
                    type: "Stock",
                    overfulfillmentPercentage: `${(((orderData.fulfilled_rquirement/orderData.requirement)-1)* 100).toFixed(2)}%`,
                    grain: orderData.grain == "short" ? "Short" : "Long",
                    customercode: "-",
                    customername: "-",
                    customer_alias: "-",
                    size: `${item.width}${
                      item.length ? ` x ${item.length}` : ""
                    } ${
                      item?.units && item.units?.width
                        ? lengthUnit[item.units.width].displayName.toUpperCase()
                        : "CM"
                    }`,
                    length: item.length,
                    width: item.width,
                    productInfo: item.product_info,
                    productspec: item.product_spec,
                    plannedReels: "-",
                    plannedWeight: "-",
                    fulflilledReels: orderData.fulfilled_rquirement,
                    fulflilledWeight:
                      orderData.fulfilled_rquirement_weight.toFixed(3) +
                      " " +
                      (orderData.units?.fulfilled_rquirement_weight
                        ? capitalize(
                            weightUnit[
                              orderData.units.fulfilled_rquirement_weight
                            ].displayName
                          )
                        : "T"),
                    unFulflilledReels: "-",
                    unFulflilledWeight: "-",
                    priority: false,
                    deliverydate: "-",
                    external_order_id: item.external_order_id,
                    remarks: item.remarks,
                    no_of_sheets: item.quantity,
                    units: item.units,
                    consignee_name: "-",
                    consignee_code: "-",
                    fWeight: orderData.fulfilled_rquirement_weight,
                    fWeightUnit:
                      orderData?.units && orderData.units?.requirement_weight
                        ? capitalize(
                            weightUnit[orderData.units.requirement_weight]
                              .displayName
                          )
                        : "T",
                  };
                });

                setOrderDetailsList([...orderList, ...sizesList]);
              })
              .catch((error) => console.log(error));
          } else {
            setOrderDetailsList(orderList);
          }
        })
        .catch((error) => console.log(error)));
  };

  const holdModalShow = () => {
    setVisibleHold(true);
  };

  const holdModalClose = () => {
    setVisibleHold(false);
  };

  const holdModalConfirm = () => {
    holdProduction();
    setVisibleHold(false);
  };

  const showCancelJobCardDrawer = () => {
    setViewCancelJobCardDrawer(true);
  };

  const closeCancelJobCardDrawer = () => {
    setViewCancelJobCardDrawer(false);
  };

  const closeProduction = () => {
    setSelectedParentReel();
    setViewCloseProductionDrawer(false);
  };

  const showCloseProduction = (id) => {
    setSelectedParentReel(id);
    setViewCloseProductionDrawer(true);
  };

  const closeCancelProduction = () => {
    setSelectedParentReel();
    setViewCancelProductionDrawer(false);
  };

  const onCloseCancelBack = (id) => {
    showParentReelJobCard(id);
    setViewCancelProductionDrawer(false);
  };

  const showCancelProduction = (id) => {
    setSelectedParentReel(id);
    setViewCancelProductionDrawer(true);
  };

  const closeParentReelJobCard = () => {
    setSelectedParentReel();
    setViewParentReelJobCardDrawer(false);
  };

  const closeMapToReel = () => {
    setSelectedParentReel();
    setViewMapToReelDrawer(false);
  };

  const onCloseParentReelCancel = (id) => {
    setViewParentReelJobCardDrawer(false);
    showCancelProduction(id);
  };

  const holdProduction = () => {
    changeProductionJobCardState({ id: jobId, state: "hold" })
      .then((response) => {
        setActiveTab("1");
        setActionResponse(response);
        setReFetch(true);
        showToaster();
      })
      .catch((error) => {
        setActionResponse(error.response.data);
        showToaster();
      });
  };

  const completeProduction = () => {
    changeProductionJobCardState({ id: jobId, state: "complete" })
      .then((response) => {
        setActiveTab("1");
        setActionResponse({});
        setReFetch(true);
        showToaster();
      })
      .catch((error) => {
        setActionResponse(error.response.data);
        showToaster();
      });
  };

  const resumeProduction = () => {
    changeProductionJobCardState({ id: jobId, state: "in_production" })
      .then((response) => {
        setActiveTab("1");
        setActionResponse(response);
        setReFetch(true);
        showToaster();
      })
      .catch((error) => {
        setActionResponse(error.response.data);
        showToaster();
      });
  };

  const routeChange = (record) => {
    console.log(jobId, record.parentReel);
    if (type == "production") {
      history(
        "../production-job-cards/job-card-details/print-parent-reel/pdf",
        {
          state: {
            jobId: jobId,
            parentReel: record.parentReel,
            machine_type: record.machine_type
              ? record.machine_type
              : "rewinder",
          },
        }
      );
    } else {
      history("../job-card-details/print-parent-reel/pdf", {
        state: {
          jobId: jobId,
          parentReel: record.parentReel,
          machine_type: record.machine_type ? record.machine_type : "rewinder",
        },
      });
    }
  };

  const onCancelSuccess = () => {
    setActiveTab("1");
  };

  useEffect(() => {
      setPageSize(10);
      setCurrentPage(1);
    }, [activeTab]);

  useEffect(() => {
    if (location.state)
      setSearchParams({
        id: location.state.id,
        type: location.state.type,
        cutter_type: location.state.cutter_type,
      });
  }, []);

  useEffect(() => {
    (async () => {
      getUnitData()
        .then((response) => {
          setUnitData(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    })();
  }, []);

  useEffect(() => {
    if (reFetch) {
      getJobCardDetailsById();
      setReFetch(false);
    }
  }, [reFetch]);

  useEffect(() => {
    if (acceptedSolution.solution) {
      fetchOrders();
      // setSizeFulfillmentDetails([
      //   {
      //     length: 40,
      //     breadth: 65,
      //     sheet_requirement: 10000,
      //     sheet_requirement_ub: 10000,
      //     sheet_requirement_lb: 6000,
      //     fulfilled_sheet: 10000,
      //     unfulfilled_sheet: 0,
      //     weight_requirement: 0.364,
      //     weight_requirement_ub: 0.364,
      //     weight_requirement_lb: 0.21839999999999998,
      //     fulfilled_weight: 0.364,
      //     unfulfilled_weight: 0.0,
      //   },
      //   {
      //     length: 40,
      //     breadth: 60,
      //     sheet_requirement: 10000,
      //     sheet_requirement_ub: 10000,
      //     sheet_requirement_lb: 8000,
      //     fulfilled_sheet: 10000,
      //     unfulfilled_sheet: 0,
      //     weight_requirement: 0.33599999999999997,
      //     weight_requirement_ub: 0.33599999999999997,
      //     weight_requirement_lb: 0.2688,
      //     fulfilled_weight: 0.33599999999999997,
      //     unfulfilled_weight: 0.0,
      //   },
      //   {
      //     length: 44,
      //     breadth: 54,
      //     sheet_requirement: 10000,
      //     sheet_requirement_ub: 10000,
      //     sheet_requirement_lb: 7000,
      //     fulfilled_sheet: 7001,
      //     unfulfilled_sheet: 2999,
      //     weight_requirement: 0.33264,
      //     weight_requirement_ub: 0.33264,
      //     weight_requirement_lb: 0.232848,
      //     fulfilled_weight: 0.23288126399999998,
      //     unfulfilled_weight: 0.099758736,
      //   },
      // ]);
    }
  }, [acceptedSolution]);

  useEffect(() => {
    if (
      (jobCard?.state === "in_production" ||
        jobCard?.state === "complete" ||
        jobCard?.state === "hold") &&
      reFetchJumboReels
    ) {
      getJumboReelDetailsById(jobId)
        .then((response) => {
          let isCancelDisabled = false;
          setJumboReelData(
            response.data.data.map((item) => {
              if (item.status == "produced") setProducedParentReelBool(true);
              if (
                item.status == "mapped" ||
                item.status == "produced" ||
                item.status == "rejected"
              ) {
                setDisableCancel(true);
                isCancelDisabled = true;
              }
              return {
                leftTrim: item.left_edge_trim,
                rightTrim: item.right_edge_trim,
                deckleWidth: item.deckle_width,
                priority: item.priority,
                parentReel: item.parent_reel.id,
                combinations: item.combinations,
                comWidth: item.d_com_width?.toFixed(3),
                trimLoss: item.trim_loss,
                netTrimLoss: item.net_trim_loss,
                deliverydate: item.earliest_delivery_date,
                mappedJumboRoll: item.mapped_jumbo_reels,
                status:
                  item.status == "open"
                    ? "Not Mapped"
                    : item.status == "cancel"
                    ? "Cancelled"
                    : capitalize(item.status),
                core_id: item.core_id,
                reel_od: item.reel_od,
                machine_type: item.machine_type,
                chop_size:
                  item.cutter_type === "duplex"
                    ? item.left_length +
                      " " +
                      `${
                        item?.units && item.units?.left_length
                          ? lengthUnit[
                              item.units.left_length
                            ]?.displayName?.toUpperCase()
                          : "CM"
                      }` +
                      "<br/>" +
                      item.right_length +
                      " " +
                      `${
                        item?.units && item.units?.right_length
                          ? lengthUnit[
                              item.units.right_length
                            ]?.displayName?.toUpperCase()
                          : "CM"
                      }`
                    : item.combinations[0]?.length
                    ? item.combinations[0]?.length +
                      " " +
                      `${
                        item?.units && item.units?.length
                          ? lengthUnit[
                              item.units?.length
                            ]?.displayName?.toUpperCase()
                          : "CM"
                      }`
                    : "",
                left_length: item.left_length,
                right_length: item.right_length,
                units: item.units,
              };
            })
          );
          if (!isCancelDisabled) setDisableCancel(false);
        })
        .catch((error) => console.log(error));
      setReFetchJumboReels(false);
    }
  }, [jobCard, reFetchJumboReels]);

  useEffect(() => {
    for (let i = 0; i < jumboReelData?.length; i++) {
      if (jumboReelData[i].status !== "Cancel")
        if (jumboReelData[i].status == "Mapped") setDisablePrint(false);
        else {
          setDisablePrint(true);
          break;
        }
    }
    return () => {};
  }, [jumboReelData]);

  // Column heads
  // const columnsHead = [
  //   {
  //     title: "Po/So.No",
  //     dataIndex: "pono",
  //     width: "8%",
  //     fixed: "left",
  //     align: "center",
  //     render: (text, record) => {
  //       const value =
  //         record.category === "po"
  //           ? toHandlePOName(record.pono)
  //           : record.category === "so"
  //           ? toHandlePOName(record.sono)
  //           : toHandlePOName(record.pono);

  //       return (
  //         <span style={{ whiteSpace: "normal", wordBreak: "break-word", lineHeight: "1.4" }}>
  //           {value
  //             ?.match(/.{1,15}/g)
  //             ?.map((chunk, index) => (
  //               <span key={index}>
  //                 {chunk}
  //                 <br />
  //               </span>
  //             ))}
  //         </span>
  //       );
  //     }

  //   },
  //   {
  //     title: "Order No/Stock No",
  //     dataIndex: "orderno",
  //     width: "9%",
  //     fixed: "left",
  //   },
  //   {
  //     title: "Type",
  //     dataIndex: "type",
  //     width: "6%",
  //     fixed: "left",
  //   },
  //   {
  //     title: "Customer",
  //     dataIndex: "customer_alias",
  //     width: "9%",
  //     align: "left",
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={`${record.customercode}-${record.customername}`}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             {record?.customer_alias || "-"}
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //   },
  //   {
  //     title: (
  //       <div>
  //         Product Spec
  //         <Styled style={{ display: "inline-flex" }}>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={
  //               "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
  //             }
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <span className="infoIcon"></span>
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     dataIndex: "productspec",
  //     width: "14%",
  //   },
  //   {
  //     title: "Size(WxL)",
  //     dataIndex: "size",
  //     width: "9%",
  //   },
  //   {
  //     title: "Matched Grain",
  //     dataIndex: "grain",
  //     width: "9%",
  //   },
  //   {
  //     title: "Planned Quantity",
  //     dataIndex: "plannedReels",
  //     width: "8%",
  //     // render: (text, record) => `${text} ${capitalize(record.type)}s`,
  //   },
  //   {
  //     title: "Planned Weight",
  //     dataIndex: "plannedWeight",
  //     width: "10%",
  //   },
  //   {
  //     title: "Fulfilled Quantity",
  //     dataIndex: "fulflilledReels",
  //     width: "8%",
  //     // render: (text, record) => `${text} ${capitalize(record.type)}s`,
  //   },
  //   {
  //     title: "Fulfilled Weight",
  //     dataIndex: "fulflilledWeight",
  //     width: "10%",
  //   },
  //   // {
  //   //   title: "Type",
  //   //   dataIndex: "type",
  //   //   width: "5%",
  //   // },
  //   {
  //     title: "Del Date",
  //     dataIndex: "deliverydate",
  //     width: "10%",
  //   },
  //   {
  //     title: "Remarks",
  //     dataIndex: "remarks",
  //     width: "8%",
  //     render: (text, record) =>
  //       record.type == "Order" && (
  //         <div className="actionBtn">
  //           <Styled>
  //             <Tooltip
  //               placement="bottomRight"
  //               title={record.remarks}
  //               className="edit-tooltip"
  //               getPopupContainer={(triggerNode) => triggerNode}
  //             >
  //               <Button style={{ cursor: "default" }}>
  //                 <Iconmoon icon="message" size={16} color="#EA655B" />
  //               </Button>
  //             </Tooltip>
  //           </Styled>
  //         </div>
  //       ),
  //     align: "center",
  //   },
  //   {
  //     title: "Actions",
  //     dataIndex: "action",
  //     width: "8%",
  //     render: (text, record) =>
  //       record.type == "Order" && (
  //         <div className="actionBtn">
  //           <Styled>
  //             <Tooltip
  //               placement="bottomRight"
  //               title={"View details of this order"}
  //               className="edit-tooltip"
  //               getPopupContainer={(triggerNode) => triggerNode}
  //             >
  //               <Button onClick={() => showViewDrawer(record.orderno,record)}>
  //                 <Iconmoon icon="file-view" size={16} color="#A19F9D" />
  //               </Button>
  //             </Tooltip>
  //           </Styled>
  //         </div>
  //       ),
  //     align: "center",
  //   },
  // ];

  // const unfulfilledColumnsHead = [
  //   {
  //     title: "Po/So.No",
  //     dataIndex: "pono",
  //     width: "8%",
  //     fixed: "left",
  //     align: "center",
  //     render: (text, record) => {
  //       const value =
  //         record.category === "po"
  //           ? toHandlePOName(record.pono)
  //           : record.category === "so"
  //           ? toHandlePOName(record.sono)
  //           : toHandlePOName(record.pono);

  //       return (
  //         <span style={{ whiteSpace: "normal", wordBreak: "break-word", lineHeight: "1.4" }}>
  //           {value
  //             ?.match(/.{1,15}/g)
  //             ?.map((chunk, index) => (
  //               <span key={index}>
  //                 {chunk}
  //                 <br />
  //               </span>
  //             ))}
  //         </span>
  //       );
  //     }

  //   },
  //   {
  //     title: "Order No/Stock No",
  //     dataIndex: "orderno",
  //     width: "9%",
  //     fixed: "left",
  //   },
  //   {
  //     title: "Type",
  //     dataIndex: "type",
  //     width: "6%",
  //     fixed: "left",
  //   },
  //   {
  //     title: "Customer",
  //     dataIndex: "customer_alias",
  //     width: "9%",
  //     align: "left",
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={`${record.customercode}-${record.customername}`}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             {record?.customer_alias || "-"}
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //   },
  //   {
  //     title: (
  //       <div>
  //         Product Spec
  //         <Styled style={{ display: "inline-flex" }}>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={
  //               "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
  //             }
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <span className="infoIcon"></span>
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     dataIndex: "productspec",
  //     width: "14%",
  //   },
  //   {
  //     title: "Size(WxL)",
  //     dataIndex: "size",
  //     width: "9%",
  //   },
  //   {
  //     title: "Matched Grain",
  //     dataIndex: "grain",
  //     width: "9%",
  //   },
  //   {
  //     title: "Planned Quantity",
  //     dataIndex: "plannedReels",
  //     width: "8%",
  //     // render: (text, record) => `${text} ${capitalize(record.type)}s`,
  //   },
  //   {
  //     title: "Planned Weight",
  //     dataIndex: "plannedWeight",
  //     width: "10%",
  //   },
  //   {
  //     title: "Unfulfilled Quantity",
  //     dataIndex: "unFulflilledReels",
  //     width: "8%",
  //     // render: (text, record) => `${text} ${capitalize(record.type)}s`,
  //   },
  //   {
  //     title: "Unfulfilled Weight",
  //     dataIndex: "unFulflilledWeight",
  //     width: "10%",
  //   },
  //   // {
  //   //   title: "Type",
  //   //   dataIndex: "type",
  //   //   width: "5%",
  //   // },
  //   {
  //     title: "Del Date",
  //     dataIndex: "deliverydate",
  //     width: "10%",
  //   },
  //   {
  //     title: "Remarks",
  //     dataIndex: "remarks",
  //     width: "8%",
  //     render: (text, record) =>
  //       record.type == "Order" && (
  //         <div className="actionBtn">
  //           <Styled>
  //             <Tooltip
  //               placement="bottomRight"
  //               title={record.remarks}
  //               className="edit-tooltip"
  //               getPopupContainer={(triggerNode) => triggerNode}
  //             >
  //               <Button style={{ cursor: "default" }}>
  //                 <Iconmoon icon="message" size={16} color="#EA655B" />
  //               </Button>
  //             </Tooltip>
  //           </Styled>
  //         </div>
  //       ),
  //     align: "center",
  //   },
  //   {
  //     title: "Actions",
  //     dataIndex: "action",
  //     width: "8%",
  //     render: (text, record) =>
  //       record.type == "Order" && (
  //         <div className="actionBtn">
  //           <Styled>
  //             <Tooltip
  //               placement="bottomRight"
  //               title={"View details of this order"}
  //               className="edit-tooltip"
  //               getPopupContainer={(triggerNode) => triggerNode}
  //             >
  //               <Button onClick={() => showViewDrawer(record.orderno,record)}>
  //                 <Iconmoon icon="file-view" size={16} color="#A19F9D" />
  //               </Button>
  //             </Tooltip>
  //           </Styled>
  //         </div>
  //       ),
  //     align: "center",
  //   },
  // ];

  const sizeFulfillmentColumnsHead = [
    {
      title: "Sr.No",
      dataIndex: "key",
      width: "7%",
      fixed: "left",
      align: "center",
    },
    // {
    //   title: "Type",
    //   dataIndex: "type",
    //   width: "7%",
    //   fixed: "left",
    // },
    {
      title: "Size(WxL)",
      dataIndex: "size",
      width: "9%",
    },
    {
      title: "Planned Weight",
      dataIndex: "plannedWeight",
      width: "10%",
    },
    {
      title: "Planned Quantity",
      dataIndex: "plannedReels",
      width: "8%",
      // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    },
    {
      title: "Fulfilled Weight",
      dataIndex: "fulflilledWeight",
      width: "10%",
    },
    {
      title: "Fulfilled Quantity",
      dataIndex: "fulflilledReels",
      width: "8%",
      // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    },
    {
      title: "UnFulfilled/(Overfulfilled) Weight",
      dataIndex: "unFulflilledWeight",
      width: "10%",
      render: (text, record) => {
        const parsedValue = parseFloat(text?.split(" ")[0]);
        const positiveValue = Math.abs(parsedValue);
        return parsedValue < 0 ? (
          <div>
            ({positiveValue} {text?.split(" ")[1]})
          </div>
        ) : (
          text
        );
      },
    },
    {
      title: "Unfulfilled/(Overfulfilled) Quantity",
      dataIndex: "unFulflilledReels",
      width: "8%",
      render: (text, record) => {
        const parsedValue = parseFloat(text);
        const positiveValue = Math.abs(parsedValue);
        return parsedValue < 0 ? <div>({positiveValue})</div> : text;
      },
    },
  ];

  const mapJumboReelColumns = [
    {
      title: "Combination",
      dataIndex: "combinations",
      width: "25%",
      sorter: {
        compare: (a, b) => {},
      },
      render: (text, record) => {
        let leftPartitionData = "( ";
        let rightPartitionData = "( ";
        if (cutter_type == "duplex") {
          text.forEach((order, index) => {
            if (order.position === "left")
              leftPartitionData = leftPartitionData + order.width + " + ";
            else rightPartitionData = rightPartitionData + order.width + " + ";
          });

          let leftData = text.filter((order) => order.position === "left");
          let rightData = text.filter((order) => order.position === "right");

          if (leftData.length && rightData.length) {
            leftPartitionData = leftPartitionData.substring(
              0,
              leftPartitionData.length - 2
            );
            leftPartitionData =
              leftPartitionData + ") x " + record.left_length + " + ";
            rightPartitionData = rightPartitionData.substring(
              0,
              rightPartitionData.length - 2
            );
            rightPartitionData =
              rightPartitionData + ") x " + record.right_length;
          }

          if (!leftData.length) {
            leftPartitionData = "";
            rightPartitionData = rightPartitionData.substring(
              0,
              rightPartitionData.length - 2
            );
            rightPartitionData =
              rightPartitionData + ") x " + record.right_length;
          }

          if (!rightData.length) {
            rightPartitionData = "";
            leftPartitionData = leftPartitionData.substring(
              0,
              leftPartitionData.length - 2
            );
            leftPartitionData = leftPartitionData + ") x " + record.left_length;
          }
        }
        let partitionData = leftPartitionData + rightPartitionData;

        return (
          <div className="combination-rl">
            {record.machine_type !== "cutter" ? (
              <h4>
                {text.map(
                  (item, index, array) =>
                    `${item.width} ${index + 1 !== array.length ? "+" : ""}`
                )}
                {record.priority && <span dataset="Priority">Priority</span>}
              </h4>
            ) : cutter_type === "simplex" ? (
              <h4>
                {`(`}
                {text.map(
                  (item, index) =>
                    `${item.width} ${index + 1 !== text.length ? "+" : ""}`
                )}{" "}
                {`) X ${text[0].length}`}
                {record.priority && <span dataset="Priority">Priority</span>}
              </h4>
            ) : (
              <h4>
                {`${partitionData}`}
                {record.priority && <span dataset="Priority">Priority</span>}
              </h4>
            )}
            {record.core_id &&
            record.reel_od &&
            record.machine_type !== "cutter" ? (
              <p>Parent Reel: {record.parentReel}</p>
            ) : (
              <p>Parent Set: {record.parentReel}</p>
            )}
          </div>
        );
      },
    },
    {
      title: "Chop Size",
      dataIndex: "chop_size",
      width: "12%",
      align: "center",
      render: (text, record) => {
        return <span dangerouslySetInnerHTML={{ __html: text }} />;
      },
    },
    {
      title: "D.Com.Width",
      dataIndex: "comWidth",
      width: "10%",
      align: "center",
      render: (text, record) =>
        `${text} ${
          record?.units && record?.units?.d_com_width
            ? lengthUnit[record.units.d_com_width]?.displayName?.toUpperCase()
            : "CM"
        }`,
    },
    {
      title: "TRIM LOSS",
      dataIndex: "trimLoss",
      width: "8%",
      align: "center",
      render: (text, record) =>
        `${text.toFixed(2)} ${
          record?.units && record?.units?.trim_loss
            ? lengthUnit[record.units.trim_loss]?.displayName?.toUpperCase()
            : "CM"
        }`,
    },
    {
      title: (
        <div>
          NET TRIM LOSS
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={"Net trim loss including the edge trim"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      dataIndex: "netTrimLoss",
      width: "8%",
      align: "center",
      render: (text, record) =>
        `${text.toFixed(2)} ${
          record?.units && record?.units?.net_trim_loss
            ? lengthUnit[record.units.net_trim_loss]?.displayName?.toUpperCase()
            : "CM"
        }`,
    },
    {
      title: "EARLIEST DELIVERY DATE",
      dataIndex: "deliverydate",
      width: "17%",
      align: "center",
      sorter: {
        compare: (a, b) => new Date(a.deliverydate) - new Date(b.deliverydate),
      },
      render: (text) => (text ? moment(text)?.format("DD MMM YYYY") : "-"),
    },
    {
      title: "MAPPED JUMBO ROLL",
      dataIndex: "mappedJumboRoll",
      width: "15%",
      align: "center",
      render: (text) => {
        return text.length == 0
          ? "-"
          : text.map(
              (item, index, array) =>
                `${item.number}${index + 1 != array.length ? ", " : ""}`
            );
      },
    },
    {
      title: "PRODUCTION STATUS",
      dataIndex: "status",
      width: "13%",
      render: (text, record) => (
        <div className="statusVal" dataval={record.status}>
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={
                record.reel_od && record.core_id
                  ? text == "Produced"
                    ? "The production of this parent reel is completed"
                    : text == "Mapped"
                    ? "This parent reel is mapped to jumbo roll for rewinding"
                    : text == "Not Mapped"
                    ? "This parent reel is not mapped to jumbo roll yet"
                    : text == "Cancelled"
                    ? "The production of this parent reel is cancelled"
                    : null
                  : text == "Produced"
                  ? " The production of this parent set is completed"
                  : text == "Mapped"
                  ? "The parent set has been mapped to a jumbo roll"
                  : text == "Not Mapped"
                  ? "The parent set is not mapped to a jumbo roll yet"
                  : text == "Cancelled"
                  ? "The production of this parent set is cancelled"
                  : text == "Rejected"
                  ? "The production of this parent set is rejected "
                  : null
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {text}
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
    {
      title: "ACTIONS",
      dataIndex: "action",
      width: "15%",
      align: "center",
      render: (text, record) => (
        <div
          className="actionBtn"
          style={{
            display: type == "production" ? "flex" : "",
            justifyContent: type == "production" ? "end" : "",
          }}
        >
          {userDetails.roles.production.job_cards.edit &&
            record.status == "Not Mapped" &&
            jobCard.state !== "hold" &&
            jobCard.state !== "complete" &&
            type == "production" && (
              <Styled>
                <Tooltip
                  placement="bottomRight"
                  title={"Map jumbo roll"}
                  className="edit-tooltip"
                  getPopupContainer={(triggerNode) => triggerNode}
                >
                  <Button
                    onClick={() => showMapToReel(record.parentReel, "add")}
                  >
                    <img style={{ width: "18px" }} src={Mapping} />
                  </Button>
                </Tooltip>
              </Styled>
            )}
          {userDetails.roles.production.job_cards.edit &&
            record.status == "Mapped" &&
            jobCard.state !== "hold" &&
            jobCard.state !== "complete" &&
            type == "production" && (
              <>
                <Styled>
                  <Tooltip
                    placement="bottomRight"
                    title={"Edit jumbo roll mapping"}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Button
                      onClick={() => showMapToReel(record.parentReel, "edit")}
                    >
                      <img style={{ width: "18px" }} src={MappingEdit} />
                    </Button>
                  </Tooltip>
                </Styled>
                <Styled>
                  <Tooltip
                    placement="bottomRight"
                    title={"Close production for the parent reel"}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Button
                      onClick={() => showCloseProduction(record.parentReel)}
                    >
                      <img style={{ width: "17px" }} src={CloseProduction} />
                    </Button>
                  </Tooltip>
                </Styled>
              </>
            )}
          {((record.status == "Mapped" &&
            jobCard.state !== "hold" &&
            jobCard.state !== "complete" &&
            type == "production") ||
            (record.status == "Mapped" && type != "production")) && (
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={"Print details of the parent reel"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button onClick={() => routeChange(record)}>
                  <img style={{ width: "20px" }} src={PrintIcon} />
                </Button>
              </Tooltip>
            </Styled>
          )}
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"View parent reel details"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button onClick={() => showParentReelJobCard(record.parentReel)}>
                <Iconmoon icon="file-view" size={16} color="#605E5C" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
    },
  ];

  const orderFulfillmentColumnsHead = [
    {
      title: "Po/So.No",
      dataIndex: "pono",
      width: "8%",
      fixed: "left",
      align: "center",
      render: (text, record) => {
        const value =
          record.category === "po"
            ? toHandlePOName(record.pono)
            : record.category === "so"
            ? toHandlePOName(record.sono)
            : toHandlePOName(record.pono);

        return (
          <span
            style={{
              whiteSpace: "normal",
              wordBreak: "break-word",
              lineHeight: "1.4",
            }}
          >
            {value?.match(/.{1,15}/g)?.map((chunk, index) => (
              <span key={index}>
                {chunk}
                <br />
              </span>
            ))}
          </span>
        );
      },
    },
    {
      title: "Order No/Stock No",
      dataIndex: "orderno",
      width: "9%",
      fixed: "left",
    },
    
    {
      title: (
        <div>
          Product Spec
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={`The product specification is in the ${format}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      dataIndex: "productspec",
      width: "14%",
    },
    {
      title: "Size(WxL)",
      dataIndex: "size",
      width: "9%",
    },
    {
      title: "Matched Grain",
      dataIndex: "grain",
      width: "9%",
    },
    {
      title: "Planned Weight",
      dataIndex: "plannedWeight",
      width: "10%",
    },
    {
      title: "Planned Quantity",
      dataIndex: "plannedReels",
      width: "8%",
      // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    },
    {
      title: "Fulfilled Quantity",
      dataIndex: "fulflilledReels",
      width: "8%",
      // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    },
    {
      title: "Overfulfilment %",
      dataIndex: "overfulfillmentPercentage",
      width: "10%",
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      width: "8%",
      render: (text, record) =>
        record.type == "Order" && (
          <div className="actionBtn">
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={record.remarks}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button style={{ cursor: "default" }}>
                  <Iconmoon icon="message" size={16} color="#EA655B" />
                </Button>
              </Tooltip>
            </Styled>
          </div>
        ),
      align: "center",
    },
    {
      title: "Actions",
      dataIndex: "action",
      width: "8%",
      render: (text, record) =>
        record.type == "Order" && (
          <div className="actionBtn">
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={"View details of this order"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button onClick={() => showViewDrawer(record.orderno, record)}>
                  <Iconmoon icon="file-view" size={16} color="#A19F9D" />
                </Button>
              </Tooltip>
            </Styled>
          </div>
        ),
      align: "center",
    },
  ];

  const fullUnfulfilledColumnsHead = [
    {
      title: "Po/So.No",
      dataIndex: "pono",
      width: "8%",
      fixed: "left",
      align: "center",
      render: (text, record) => {
        const value =
          record.category === "po"
            ? toHandlePOName(record.pono)
            : record.category === "so"
            ? toHandlePOName(record.sono)
            : toHandlePOName(record.pono);

        return (
          <span
            style={{
              whiteSpace: "normal",
              wordBreak: "break-word",
              lineHeight: "1.4",
            }}
          >
            {value?.match(/.{1,15}/g)?.map((chunk, index) => (
              <span key={index}>
                {chunk}
                <br />
              </span>
            ))}
          </span>
        );
      },
    },
    {
      title: "Order No/Stock No",
      dataIndex: "orderno",
      width: "9%",
      fixed: "left",
    },
    {
      title: "Type",
      dataIndex: "type",
      width: "6%",
      fixed: "left",
    },
    {
      title: "Customer",
      dataIndex: "customer_alias",
      width: "9%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={`${record.customercode}-${record.customername}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {record?.customer_alias || "-"}
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    {
      title: (
        <div>
          Product Spec
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={`The product specification is in the ${format}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      dataIndex: "productspec",
      width: "14%",
    },
    {
      title: "Size(WxL)",
      dataIndex: "size",
      width: "9%",
    },
    {
      title: "Matched Grain",
      dataIndex: "grain",
      width: "9%",
    },
    {
      title: "Planned Quantity",
      dataIndex: "plannedReels",
      width: "8%",
      // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    },
    {
      title: "Planned Weight",
      dataIndex: "plannedWeight",
      width: "10%",
    },
    {
      title: "Unfulfilled Quantity",
      dataIndex: "unFulflilledReels",
      width: "8%",
      // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    },
    {
      title: "Unfulfilled Weight",
      dataIndex: "unFulflilledWeight",
      width: "10%",
    },
    // {
    //   title: "Type",
    //   dataIndex: "type",
    //   width: "5%",
    // },
    {
      title: "Del Date",
      dataIndex: "deliverydate",
      width: "10%",
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      width: "8%",
      render: (text, record) =>
        record.type == "Order" && (
          <div className="actionBtn">
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={record.remarks}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button style={{ cursor: "default" }}>
                  <Iconmoon icon="message" size={16} color="#EA655B" />
                </Button>
              </Tooltip>
            </Styled>
          </div>
        ),
      align: "center",
    },
    {
      title: "Actions",
      dataIndex: "action",
      width: "8%",
      render: (text, record) =>
        record.type == "Order" && (
          <div className="actionBtn">
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={"View details of this order"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button onClick={() => showViewDrawer(record.orderno, record)}>
                  <Iconmoon icon="file-view" size={16} color="#A19F9D" />
                </Button>
              </Tooltip>
            </Styled>
          </div>
        ),
      align: "center",
    },
  ];

  const filteredColumns2 = fullUnfulfilledColumnsHead.filter(
    (col) => !columnBlacklist.includes(col.dataIndex) && (orderManagementSettings?.fetch_balance_quantity?.value || col.dataIndex != "balance_qty")
  );
  const unfulfilledColumnsHead = filteredColumns2;

  const printJobCard = (record) => {
    if (type == "deckle") {
      history("../deckle-job-cards/job-card-details/print-job-card/pdf", {
        state: {
          jobId: jobId,
          jobcardCode: getJCCode(jobCard.jobcard_code),
          machine_type: record.jobcard.group.machines[0].machine_type
            ? record.jobcard.group.machines[0].machine_type
            : "rewinder",
        },
      });
    } else {
      history("../Production-job-cards/job-card-details/print-job-card/pdf", {
        state: {
          jobId: jobId,
          jobcardCode: getJCCode(jobCard.jobcard_code),
          machine_type: record.jobcard.group.machines[0].machine_type
            ? record.jobcard.group.machines[0].machine_type
            : "rewinder",
        },
      });
    }
  };

  const handleDropdownClick = async (record, key) => {
    try {
      switch (key) {
        case "sendForReview": // sendForReview
          const response1 = await changeProductionJobCardState({
            id: jobId,
            state: "under_review",
          });
          // setUnderReviewJobCards([...underReviewJobcards, record]);
          // setGridView(true);
          setReFetch(true);
          showToaster();

          break;

        case "markCancelled": // markCancelled
          const response2 = await changeProductionJobCardState({
            id: jobId,
            state: "cancel",
          });
          // setCancelledJobCards([...cancelledJobcards, record]);
          // setGridView(true);
          setReFetch(true);
          showToaster();

          break;

        case "markCompleted": // markCompleted
          const response3 = await changeProductionJobCardState({
            id: jobId,
            state: "complete",
          });
          // setCompleteCards([...completeCards, record]);
          // setGridView(true);
          setReFetch(true);
          showToaster();
          break;

        case "replan":
          const response4 = await replanJobcard(
            {
              jobcard: jobId,
              // state: "complete",
            },
            cutter_type
          );
          setIsReplanClicked(true);
          break;
        default:
          console.warn("Unknown dropdown key:", key);
      }
    } catch (error) {
      console.error("Error handling dropdown click:", error);
      setActionResponse({
        error: error.response.data.error,
        msg: error.response.data.msg,
      });
      showToaster();
    }
  };

  const getJobCardsListDetails = (
    jobcardIds,
    parentJobCardId = 0,
    uuid = ""
  ) => {
    getJobCardsDetails({ jobcards: jobcardIds })
      .then((response) => {
        if (!createNewSolutionClicked.isClicked) {
          setJobCardDetailsList(response);
        } else {
          let detailsList = jobCardDetailsList;
          let filteredJobCardIndex = detailsList.findIndex(function (
            jobCardDetails
          ) {
            return jobCardDetails.uuid == uuid;
          });
          if (filteredJobCardIndex !== -1) {
            detailsList[filteredJobCardIndex]["newlyCreatedJobCardsDetails"] =
              response;
          } else {
            console.error(`No matching job card found for uuid: ${uuid}`);
          }

          setJobCardDetailsList(detailsList);
          setCreateNewSolutionClicked({ isClicked: false, index: -1 });
          setRerendering(!rerendering);
          setSolId("3");
          setSolutionId("3");
        }
        // stockMachineValue['min_deckle_length'] = response[0].jobcard.group.machines[0].deckle_length_lb;
        // stockMachineValue['max_deckle_length'] = response[0].jobcard.group.machines[0].deckle_length_ub;
        // stockMachineValue['maximum_cutters'] = response[0].jobcard.group.machines[0].original_cutters;
        // stockMachineValue['effective_deckle_length'] = toFixedValue(parseFloat(response[0].jobcard.group.machines[0].effective_deckle_length) * CoversionFactorUnitsToCM[response[0].jobcard.group.machines[0].units.effective_deckle_length] * CoversionFactorCMToUnits[response[0].jobcard.group.machines[0].units.deckle_length_ub], 3);
        // stockMachineValue['left_edge_trim'] = response[0].jobcard.group.machines[0].left_edge_trim;
        // stockMachineValue['right_edge_trim'] = response[0].jobcard.group.machines[0].right_edge_trim;
        // stockMachineValue['units'] = response[0].jobcard.group.machines[0].units;
        // stockMachineValue['min_weight_per_partition'] = location.state.minWeight;
        // stockMachineValue['partitionWeightUnit'] = location.state.partitionWeightUnit;

        let stockMachineValue = formValuesForStock?.[jobIndex];
        const cutterMachine = response[0]?.jobcard?.group?.machines[0];
        if (cutterMachine) {
          const {
            deckle_length_lb,
            deckle_length_ub,
            left_edge_trim,
            right_edge_trim,
            original_cutters,
            effective_deckle_length,
            units,
            machine_type,
            machine_code,
          } = cutterMachine;

          const rightEdgeTrimConversionFactor =
            CoversionFactorUnitsToCM[units.right_edge_trim];
          const deckleSizeUbConversionFactor =
            CoversionFactorCMToUnits[units.deckle_length_ub];

          const minDeckleLength = deckle_length_lb;
          const maxDeckleLength =
            deckle_length_ub +
            (left_edge_trim + right_edge_trim) *
              rightEdgeTrimConversionFactor *
              deckleSizeUbConversionFactor;

          stockMachineValue = {
            ...stockMachineValue,
            min_deckle_length: minDeckleLength,
            max_deckle_length: deckle_length_ub,
            maximum_cutters: original_cutters,
            effective_deckle_length: effective_deckle_length,
            left_edge_trim: left_edge_trim,
            right_edge_trim: right_edge_trim,
            units: units,
            min_weight_per_partition: location?.state?.minWeight,
            partitionWeightUnit: location?.state?.partitionWeightUnit,
          };
        }
        setFormValuesForStock({
          ...formValuesForStock,
          [jobIndex]: stockMachineValue,
        });
      })
      .catch((error) => console.log(error));
  };
  const onClickCreateSolution = async (e, jobCardId, uuid, ind) => {
    setActiveTab("1");
    setSizeExpanded(false);
    setSizeExpanded(false);
    setSizeExpanded(false);
    setSizeExpanded(false);
    // setShowAimation(true);
    setShowAimation((prev) => {
      return { prev, [ind]: true };
    });
    if (jobCardDetailsList[jobIndex].newlyCreatedJobCardsDetails) {
      let jobcard = jobCardDetailsList;
      jobcard = jobcard[jobIndex].newlyCreatedJobCardsDetails = undefined;
      setJobCardDetailsList(jobcard);
    }
    let sizes = [];
    setCreateNewSolutionFormValuesForSizes(e);
    if (e.selectedSizes.length > 0) {
      e.selectedSizes.forEach((size) => {
        let sizeObject = {
          type: "sheet",
          id: size.stockSizeId,
          allowed_quantity: parseFloat(size.allowedQuantity),
          sheets: size.sheets,
          planned_weight: parseFloat(size.plannedWeight),
          rotation: size.rotated,
          grain: size.grain,
          length: parseFloat(size.length),
          breadth: parseFloat(size.width),
          mixed_grain: false,
          ...(size.creation_type === "required" && {
            weight_lb: parseFloat(size.weight_lb),
            weight_ub: parseFloat(size.weight_ub),
            requirement_lb: parseInt(size.requirement_lb),
            requirement_ub: parseInt(size.requirement_ub),
            priority_stock: size.priority_stock,
          }),
          units: size.units,
          creation_type: size.creation_type,
        };
        sizes.push(sizeObject);
      });
    }

    let updatedFormValues = {};
    updatedFormValues["max_deckle_length"] = e.maxDeckleLength
      ? parseFloat(e.maxDeckleLength)
      : formValuesForStock?.[jobIndex]?.max_deckle_length;
    updatedFormValues["min_deckle_length"] = e.minDeckleLength
      ? parseFloat(e.minDeckleLength)
      : formValuesForStock?.[jobIndex]?.min_deckle_length;
    updatedFormValues["left_edge_trim"] = e.minWidth
      ? parseFloat(e.minWidth)
      : formValuesForStock?.[jobIndex]?.left_edge_trim;
    updatedFormValues["right_edge_trim"] = e.maxWidth
      ? parseFloat(e.maxWidth)
      : formValuesForStock?.[jobIndex]?.right_edge_trim;
    updatedFormValues["maximum_cutters"] = e.cutters
      ? parseFloat(e.cutters)
      : formValuesForStock?.[jobIndex]?.maximum_cutters;
    updatedFormValues["effective_deckle_length"] = e.effectiveDeckleLength
      ? parseFloat(e.effectiveDeckleLength)
      : "";
    updatedFormValues["units"] = {
      max_deckle_length: e.deckleLengthUnit,
      min_deckle_length: e.deckleLengthUnit,
      left_edge_trim: e.widthUnit,
      right_edge_trim: e.widthUnit,
      effective_deckle_length: e.deckleLengthUnit,
    };

    updatedFormValues["min_weight_per_partition"] = e.min_weight_per_partition
      ? parseFloat(e.min_weight_per_partition)
      : parseFloat(formValuesForStock?.[jobIndex]?.min_weight_per_partition);
    updatedFormValues.units["min_weight_per_partition"] = e.partitionWeightUnit;

    setFormValuesForStock({
      ...formValuesForStock,
      [jobIndex]: updatedFormValues,
    });
    let request = {
      jobcard: jobCardId,
      run_type: "selected_sizes",
      machine_selection_data: {
        maximum_deckle_size: e.maxDeckleLength
          ? parseFloat(e.maxDeckleLength)
          : formValuesForStock?.[jobIndex]?.max_deckle_length,
        minimum_deckle_size: e.minDeckleLength
          ? parseFloat(e.minDeckleLength)
          : formValuesForStock?.[jobIndex]?.min_deckle_length,
        left_edge_trim: e.minWidth
          ? parseFloat(e.minWidth)
          : formValuesForStock?.[jobIndex]?.left_edge_trim,
        right_edge_trim: e.maxWidth
          ? parseFloat(e.maxWidth)
          : formValuesForStock?.[jobIndex]?.right_edge_trim,
        maximum_cutters: e.cutters
          ? parseFloat(e.cutters)
          : formValuesForStock?.[jobIndex]?.maximum_cutters,
        effective_deckle_length: e.effectiveDeckleLength
          ? parseFloat(e.effectiveDeckleLength)
          : "",
        units: {
          minimum_deckle_size: e.deckleLengthUnit,
          maximum_deckle_size: e.deckleLengthUnit,
          left_edge_trim: e.widthUnit,
          right_edge_trim: e.widthUnit,
          effective_deckle_length: e.deckleLengthUnit,
        },
      },
      sizes: sizes,
    };

    request.machine_selection_data["min_weight_per_partition"] =
      e.min_weight_per_partition
        ? parseFloat(e.min_weight_per_partition)
        : parseFloat(formValuesForStock.min_weight_per_partition);
    request.machine_selection_data.units["min_weight_per_partition"] =
      e.partitionWeightUnit;

    try {
      let jobCard =
        cutter_type == "simplex"
          ? await createNewSheetSolution(request)
          : await createNewDuplexSolution(request);
      setCreateNewSolutionClicked({ isClicked: true, index: -1 });
      // getJobCardsListDetails([jobCard.jobcard], jobCardId, uuid);
      const data = {
        done: true,
        failed_groups: [],
        jobcards: [jobCard?.jobcard],
        total_groups: 1,
      };
      history("../sheet-deckle-match-result", {
        state: {
          jobCards: data,
          parentJCid: jobCardId,
          type: "replan",
          jobcardType: jobcardType,
          isDummyJC: jobCardDetailsList[jobIndex].is_dummy,
          replan_cutter_data: {
            type: cutter_type,
          },
        },
      });
      // setShowAimation(false);
    } catch (error) {
      let updatedFormValues = {};
      updatedFormValues["max_deckle_length"] = e.maxDeckleLength
        ? parseFloat(e.maxDeckleLength)
        : formValuesForStock?.[jobIndex]?.max_deckle_length;
      updatedFormValues["min_deckle_length"] = e.minDeckleLength
        ? parseFloat(e.minDeckleLength)
        : formValuesForStock?.[jobIndex]?.min_deckle_length;
      updatedFormValues["left_edge_trim"] = e.minWidth
        ? parseFloat(e.minWidth)
        : formValuesForStock?.[jobIndex]?.left_edge_trim;
      updatedFormValues["right_edge_trim"] = e.maxWidth
        ? parseFloat(e.maxWidth)
        : formValuesForStock?.[jobIndex]?.right_edge_trim;
      updatedFormValues["maximum_cutters"] = e.cutters
        ? parseFloat(e.cutters)
        : formValuesForStock?.[jobIndex]?.maximum_cutters;
      updatedFormValues["effective_deckle_length"] = e.effectiveDeckleLength
        ? parseFloat(e.effectiveDeckleLength)
        : "";
      updatedFormValues["units"] = {
        max_deckle_length: e.deckleLengthUnit,
        min_deckle_length: e.deckleLengthUnit,
        left_edge_trim: e.widthUnit,
        right_edge_trim: e.widthUnit,
        effective_deckle_length: e.deckleLengthUnit,
        deckle_length_ub: e.deckleLengthUnit,
      };

      updatedFormValues["min_weight_per_partition"] = e.min_weight_per_partition
        ? parseFloat(e.min_weight_per_partition)
        : parseFloat(formValuesForStock.min_weight_per_partition);
      updatedFormValues.units["min_weight_per_partition"] =
        e.partitionWeightUnit;
      updatedFormValues["partitionWeightUnit"] = e.partitionWeightUnit;

      setFormValuesForStock({
        ...formValuesForStock,
        [jobIndex]: updatedFormValues,
      });

      let jobcardResp = [];

      let jobCard = await getAlgorithmCompletionStatus();
      //setCreateNewSolutionClicked({ isClicked: true, index: -1 });
      //getJobCardsListDetails([jobCard.data.failed_groups[0]], jobCardId, uuid);
      let response = await getFailedGroups({
        failed_groups: jobCard.data.failed_groups,
      });
      // setShowAimation(false);
      let detailsList = jobCardDetailsList;
      let filteredJobCardIndex = detailsList.findIndex(function (
        jobCardDetails
      ) {
        return jobCardDetails.uuid == uuid;
      });

      let data = {
        orders: [],
        partitions: [],
        sizes: [],
      };

      let jobcardData = {
        created_at: response[0].created_at,
        uuid: response[0].uuid,
        id: response[0].id,
        user_id: response[0].user_id,
        updated_at: response[0].updated_at,
        jobcard: {
          group: response[0].group,
          solution_1: { data },
          solution_2: { data },
        },
      };
      jobcardResp.push(jobcardData);

      detailsList[filteredJobCardIndex]["newlyCreatedJobCardsDetails"] =
        jobcardResp;
      setJobCardDetailsList(detailsList);
      setCreateNewSolutionClicked({ isClicked: false, index: -1 });
      setRerendering(!rerendering);
      setSolId("3");
      setSolutionId("3");
    } finally {
      setCreateNewSolutionClicked({ isClicked: false, index: -1 });
      setTimeout(() => {
        setShowAimation((prev) => {
          return { prev, [ind]: false };
        });
      }, 4000);
    }
  };
  const calcStockValues = (index) => {
    if (formValuesForStock?.[index]) return;
    const cutterMachine =
      jobCardDetailsList[index]?.jobcard?.group?.machines[0];
    let stockMachineValue = { ...formValuesForStock?.[index] };
    if (cutterMachine) {
      const {
        deckle_length_lb,
        deckle_length_ub,
        left_edge_trim,
        right_edge_trim,
        original_cutters,
        effective_deckle_length,
        units,
        machine_type,
        machine_code,
      } = cutterMachine;

      const rightEdgeTrimConversionFactor =
        CoversionFactorUnitsToCM[units?.right_edge_trim];
      const deckleSizeUbConversionFactor =
        CoversionFactorCMToUnits[units?.deckle_length_ub];

      const minDeckleLength = deckle_length_lb;
      const maxDeckleLength =
        deckle_length_ub +
        (left_edge_trim + right_edge_trim) *
          rightEdgeTrimConversionFactor *
          deckleSizeUbConversionFactor;

      stockMachineValue = {
        ...stockMachineValue,
        min_deckle_length: minDeckleLength,
        max_deckle_length: deckle_length_ub,
        maximum_cutters: original_cutters,
        effective_deckle_length: effective_deckle_length,
        left_edge_trim: left_edge_trim,
        right_edge_trim: right_edge_trim,
        units: units,
        min_weight_per_partition: location?.state?.minWeight,
        partitionWeightUnit: location?.state?.partitionWeightUnit,
      };
    }
    setFormValuesForStock({
      ...formValuesForStock,
      [index]: stockMachineValue,
    });
  };
  useEffect(() => {
    getJobCardsListDetails([jobId]);
  }, [jobId]);
  useEffect(() => {
    if (!jobCardDetailsList[jobIndex]) return;
    calcStockValues(jobIndex);
  }, [jobCardDetailsList]);
  useEffect(()=>{
    (async()=>{
      try{
        const orderMangSettings = await getWorkflowSettings("order_management");
        setOrderManagementSettings(orderMangSettings.data);
      }
      catch(e)
      {
        console.log(e);
      }
    })();
  },[]);

  return jobCard && acceptedSolution.solution && unitData ? (
    isReplanClicked ? (
      <>
        {isCreateNewSolutionClicked ? (
          <ContentMiddle>
            <div className="imageAnimate">
              <div className="imageCover">
                <LottieAnimation lotti={JobcardPrepare} />
                <p>
                  Our algorithms are cooking a job card for you <br />
                  please wait, it will take less than a minute
                </p>
              </div>
            </div>
          </ContentMiddle>
        ) : (
          <CreateNewSheetSolution
            onClickCreateSolution={(e) =>
              onClickCreateSolution(
                e,
                jobCardDetailsList[jobIndex].id,
                jobCardDetailsList[jobIndex].uuid,
                0
              )
            }
            formValuesForStock={formValuesForStock?.[jobIndex]}
            // job.jobcard.group.grouping_params.core_id
            jobCardDetails={jobCardDetailsList[jobIndex]?.jobcard}
            backButtonClicked={() => {
              setCreateNewSolutionClicked({
                isClicked: false,
                index: -1,
              });
              setIsReplanClicked(false);
              setIsCreateNewSolutionClicked(false);
            }}
            stockSizesArray={stockSizes}
            setStockSizesArray={setStockSizes}
            createNewSolutionFormValuesForSizes={
              createNewSolutionFormValuesForSizes
            }
            type={"sheet"}
            cutterType={cutter_type}
            isReplanClicked={isReplanClicked}
            dynamicStock={dynamicStock}
            solutionType={"replan"}
          ></CreateNewSheetSolution>
        )}
      </>
    ) : (
      <RightLayoutContainer>
        {/* {console.log("Jobcard", jobCard)} */}
        <PageTitleComp
          className="marginRightAdg"
          style={{ borderBottom: "0px" }}
        >
          <PageHeader
            ghost={false}
            // onBack={() => {
            //   type == "deckle"
            //     ? navigate("../job-cards")
            //     : navigate("../production-job-cards");
            // }}
            onBack={() => navigate(-2)}
            title="Job Card Details"
            extra={
              jobCard.state == "pending" && type == "deckle"
                ? [
                    <Button
                      key="1"
                      className="themeBtn noBg"
                      onClick={showRejectDrawer}
                      disabled={!userDetails.roles.approve_jobcards.edit}
                    >
                      <Iconmoon icon="wrong-file" size={14} color="#EA4E2C" />
                      Reject Job Card
                    </Button>,
                    <Button
                      key="1"
                      className="themeBtn"
                      onClick={approveModalShow}
                      disabled={!userDetails.roles.approve_jobcards.edit}
                    >
                      <Iconmoon icon="correct-file" size={14} color="#fff" />
                      Approve Job Card
                    </Button>,
                  ]
                : jobCard.state == "approved" && type == "production"
                ? [
                    <Button
                      key="1"
                      className="themeBtn"
                      onClick={showModal}
                      disabled={!userDetails.roles.production.job_cards.edit}
                    >
                      <Iconmoon icon="correct-file" size={14} color="#fff" />
                      Move to Production
                    </Button>,
                  ]
                : jobCard.state == "in_production" && type == "production"
                ? [
                    <Button
                      key="1"
                      className={`themeBtn noBg ${
                        disableCancel ? "disabled" : ""
                      }`}
                      onClick={showCancelJobCardDrawer}
                      disabled={
                        !userDetails.roles.production.job_cards.edit ||
                        disableCancel
                      }
                    >
                      <Iconmoon
                        icon="wrong"
                        size={14}
                        color={disableCancel ? "#A19F9D" : "#EA655B"}
                      />
                      Cancel Production
                    </Button>,
                    <Button
                      key="2"
                      className="themeBtn noBg"
                      onClick={holdModalShow}
                      disabled={!userDetails.roles.production.job_cards.edit}
                    >
                      <Iconmoon icon="wrong-file" size={14} color="#EA655B" />
                      Hold Production
                    </Button>,
                    <Button
                      key="3"
                      className="themeBtn"
                      onClick={completeProduction}
                      disabled={
                        !userDetails.roles.production.job_cards.edit ||
                        !producedParentReelBool
                      }
                    >
                      <Iconmoon icon="correct" size={14} color="#fff" />
                      Complete Production
                    </Button>,
                  ]
                : jobCard.state == "hold" && type == "production"
                ? [
                    <Button
                      key="1"
                      className="themeBtn"
                      onClick={resumeProduction}
                      disabled={!userDetails.roles.production.job_cards.edit}
                    >
                      <Iconmoon icon="correct-file" size={14} color="#fff" />
                      Resume Production
                    </Button>,
                  ]
                : jobCard.state === "active"
                ? [
                    <Button
                      key="1"
                      className="themeBtn noBg"
                      onClick={() =>
                        handleDropdownClick(jobcardCode, "sendForReview")
                      }
                      disabled={!userDetails.roles.approve_jobcards.edit}
                    >
                      <Iconmoon icon="file-view" size={16} color="#EA4E2C" />
                      Send for Review
                    </Button>,

                    <Button
                      key="1"
                      className="themeBtn noBg"
                      onClick={() =>
                        handleDropdownClick(jobcardCode, "markCancelled")
                      }
                      disabled={!userDetails.roles.approve_jobcards.edit}
                    >
                      <Iconmoon icon="wrong-file" size={14} color="#EA4E2C" />
                      Mark Cancelled
                    </Button>,
                    <Button
                      key="1"
                      className="themeBtn"
                      onClick={() =>
                        handleDropdownClick(jobcardCode, "markCompleted")
                      }
                      disabled={!userDetails.roles.approve_jobcards.edit}
                    >
                      <Iconmoon icon="correct-file" size={14} color="#fff" />
                      Mark Complete
                    </Button>,
                  ]
                : jobCard.state === "cancel"
                ? []
                : jobCard.state === "under_review"
                ? [
                    <Button
                      key="1"
                      className="themeBtn noBg"
                      onClick={() =>
                        handleDropdownClick(jobcardCode, "markCompleted")
                      }
                      disabled={!userDetails.roles.approve_jobcards.edit}
                    >
                      <Iconmoon icon="correct-file" size={14} color="#EA4E2C" />
                      Mark Complete
                    </Button>,
                    <Button
                      key="1"
                      className="themeBtn noBg"
                      onClick={() =>
                        handleDropdownClick(jobcardCode, "markCancelled")
                      }
                      disabled={!userDetails.roles.approve_jobcards.edit}
                    >
                      <Iconmoon icon="wrong-file" size={14} color="#EA4E2C" />
                      Mark Cancelled
                    </Button>,
                    <Button
                      key="1"
                      className="themeBtn"
                      onClick={() => handleDropdownClick(jobcardCode, "replan")}
                      disabled={!userDetails.roles.approve_jobcards.edit}
                    >
                      <Iconmoon icon="replan" size={16} color="#ffffff" />
                      Re-Plan
                    </Button>,
                  ]
                : null
            }
          ></PageHeader>
        </PageTitleComp>
        <ResultWrap>
          <DetailFields
            className="jobCardView"
            style={{ justifyContent: "flex-start" }}
          >
            <PageTitleComp style={{ borderBottom: "0" }}>
              <PageHeader
                ghost={false}
                // title={`Job Card ${jobcardCode}`}
                title={
                  jobcardCode?.length > 15 ? (
                    <Tooltip placement="bottomLeft" title={jobcardCode}>
                      <h5>{jobcardCode?.slice(0, 16) + "..."}</h5>
                    </Tooltip>
                  ) : (
                    <h5>{jobcardCode}</h5>
                  )
                }
                className="jobCardList-Grid"
              ></PageHeader>

              <div
                className={`jobCardList ${activeTab == 5 ? "fullWidth" : ""}`}
                style={{
                  alignSelf: "flex-end",
                  display: "flex",
                  gap: "10px",
                }}
              >
                <JobCardColorStatus>
                  <div className="statusVal" dataval={jobCard.state}>
                    {jobcardState(jobCard.state)}
                  </div>
                </JobCardColorStatus>

                <div
                  className="statusVal"
                  dataval={jobCard.state}
                  style={{
                    marginLeft:
                      jobCard?.state == "pending"
                        ? "10px"
                        : jobCard?.state == "approved"
                        ? "-30px"
                        : jobCard?.state == "hold"
                        ? "-43px"
                        : jobCard?.state == "in_production"
                        ? "-20px"
                        : jobCard?.state == "cancel"
                        ? "-48px"
                        : jobCard?.state == "complete"
                        ? "-34px"
                        : jobCard.state == "rejected"
                        ? "-40px"
                        : "",
                    marginTop:
                      jobCard?.state == "pending" ||
                      jobCard.state == "rejected" ||
                      jobCard.state == "approved" ||
                      jobCard?.state == "in_production" ||
                      jobCard?.state == "hold" ||
                      jobCard?.state == "cancel" ||
                      jobCard?.state == "complete"
                        ? "4px"
                        : "",
                  }}
                >
                  {/* Ply: {jobCard.ply} */}
                </div>

                {orderDetailsList && (
                  <TableList
                    style={{
                      justifyContent: "flex-end",
                      display: "flex",
                    }}
                  >
                    {/*
                  <div className="List-grid-View" onClick={printJobCardDetails}>
                    <div className="printIcon">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15.8334 6.66667H4.16669C2.78335 6.66667 1.66669 7.78334 1.66669 9.16667V14.1667H5.00002V17.5H15V14.1667H18.3334V9.16667C18.3334 7.78334 17.2167 6.66667 15.8334 6.66667ZM13.3334 15.8333H6.66669V11.6667H13.3334V15.8333ZM15.8334 10C15.375 10 15 9.62501 15 9.16667C15 8.70834 15.375 8.33334 15.8334 8.33334C16.2917 8.33334 16.6667 8.70834 16.6667 9.16667C16.6667 9.62501 16.2917 10 15.8334 10ZM15 2.50001H5.00002V5.83334H15V2.50001Z"
                          fill="#605E5C"
                        />
                      </svg>
                    </div>
                  </div>
                  */}
                  </TableList>
                )}
              </div>
              {activeTab == 5 && (
                <Button
                  key="1"
                  className={`noBgBtn ${
                    jobCard.state == "hold" || disablePrint ? "disabled" : ""
                  }`}
                  //disabled={jobCard.state == "hold" || disablePrint}
                  // onClick={() => routeChange(record)}
                  onClick={() => printJobCard(jobCard)}
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.8334 6.66667H4.16669C2.78335 6.66667 1.66669 7.78334 1.66669 9.16667V14.1667H5.00002V17.5H15V14.1667H18.3334V9.16667C18.3334 7.78334 17.2167 6.66667 15.8334 6.66667ZM13.3334 15.8333H6.66669V11.6667H13.3334V15.8333ZM15.8334 10C15.375 10 15 9.62501 15 9.16667C15 8.70834 15.375 8.33334 15.8334 8.33334C16.2917 8.33334 16.6667 8.70834 16.6667 9.16667C16.6667 9.62501 16.2917 10 15.8334 10ZM15 2.50001H5.00002V5.83334H15V2.50001Z"
                      fill={
                        jobCard.state == "hold" || disablePrint
                          ? "#A19F9D"
                          : "#EA655B"
                      }
                    />
                  </svg>
                  Print Job Card
                </Button>
              )}
            </PageTitleComp>

            <div className="MatchResult JobResulted">
              <Row span={24} style={{ margin: "0px" }}>
                {((activeTab != 5 &&
                  ((!sizeExpanded && activeTab == "2") ||
                    (!sizeExpanded && activeTab == "3") ||
                    (!sizeExpanded && activeTab == "4"))) ||
                  activeTab == "1") && (
                  <Col
                    span={15}
                    className="pipeBlock"
                    style={{ paddingRight: "20px" }}
                  >
                    {acceptedSolution.solution &&
                      (cutter_type == "simplex" ? (
                        <SheetJobCardCylinderContainer
                          jobId={jobId}
                          solution={acceptedSolution.key}
                          multiView={false}
                          acceptedSolution={acceptedSolution.solution}
                          jobCard={jobCard.jobcard}
                          print_function={
                            orderDetailsList ? printJobCardDetails : null
                          }
                          unitData={unitData}
                        />
                      ) : (
                        <DuplexJobCardCylinderContainer
                          jobId={jobId}
                          solution={acceptedSolution.key}
                          multiView={false}
                          acceptedSolution={acceptedSolution.solution}
                          jobCard={jobCard.jobcard}
                          print_function={
                            orderDetailsList ? printJobCardDetails : null
                          }
                          unitData={unitData}
                        />
                      ))}
                  </Col>
                )}
                <Col
                  span={
                    activeTab == 5
                      ? 24
                      : ((sizeExpanded && activeTab == "2") ||
                          (sizeExpanded && activeTab == "3") ||
                          (sizeExpanded && activeTab == "4")) &&
                        activeTab != "1"
                      ? 24
                      : 9
                  }
                  className="colLayoutBlock leftPostTab"
                >
                  <Tabs
                    defaultActiveKey={activeTab}
                    activeKey={activeTab}
                    className="topPostTab innerPostTab"
                    onChange={tabChange}
                  >
                    <Panes tab="Summary" key="1">
                      <div className="lossValue">
                        <Row span={24} style={{ paddingTop: "10px" }}>
                          <Col span={12}>
                            <div className="summaryValue">
                              <h5>
                                <span className="trimCut"></span> Trim Loss
                              </h5>
                              <span>
                                {acceptedSolution?.solution
                                  ? acceptedSolution?.solution?.summary?.match_trimloss_percent_area?.toFixed(
                                      3
                                    )
                                  : ""}{" "}
                                %
                              </span>
                            </div>
                          </Col>
                          <Col span={12}>
                            <div className="summaryValue">
                              <h5>
                                <span className="trimBox"></span> Fulfilment
                              </h5>
                              <span>
                                {acceptedSolution && acceptedSolution.solution
                                  ? acceptedSolution.solution?.summary?.total_fulfillment_percent.toFixed(
                                      3
                                    )
                                  : ""}
                                %
                              </span>
                            </div>
                          </Col>
                        </Row>
                        <Row span={24}>
                          <Col span={12}>
                            <div className="summaryValue">
                              <h5>
                                <span className="trimCut"></span> Net Trim Loss:{" "}
                                {acceptedSolution.solution?.summary?.net_trimloss_percent_area?.toFixed(
                                  3
                                )}
                                %<p>Loss including edge trim</p>
                              </h5>
                            </div>
                          </Col>
                          <Col span={12}>
                            <div className="summaryValue">
                              <h5>
                                <span className="trimBox"></span> Weight:{" "}
                                {acceptedSolution.solution?.summary?.job_card_weight?.toFixed(
                                  3
                                )}{" "}
                                {acceptedSolution.solution?.summary?.units &&
                                acceptedSolution.solution?.summary?.units
                                  ?.job_card_weight
                                  ? capitalize(
                                      weightUnit[
                                        acceptedSolution.solution?.summary
                                          ?.units.job_card_weight
                                      ].displayName
                                    )
                                  : "T"}
                                <p className="lesserSolution">
                                  Total weight of Job Card
                                </p>
                              </h5>
                            </div>
                          </Col>
                        </Row>
                        <Row span={24}>
                          <Col span={12}>
                            <ul>
                              <li>
                                <span>Paper Machine</span>
                                <p>
                                  {jobCard?.jobcard?.group?.machines.map(
                                    (data) => {
                                      return data.name;
                                    }
                                  )}
                                </p>
                              </li>
                              <li>
                                <span>Deckle Width</span>
                                <p>
                                  {jobCard.jobcard.group.machines.map(
                                    (data) => {
                                      return `${data.deckle_length_ub?.toFixed(
                                        3
                                      )} - ${data.deckle_length_lb?.toFixed(
                                        3
                                      )} ${
                                        data?.units &&
                                        data.units?.deckle_length_ub
                                          ? lengthUnit[
                                              data.units.deckle_length_ub
                                            ].displayName.toUpperCase()
                                          : "CM"
                                      }`;
                                    }
                                  )}{" "}
                                </p>
                              </li>

                              <li>
                                <span>Product Specifications</span>
                                <p style={{ wordWrap: "break-word" }}>
                                  {jobCard.jobcard.group.product.product_spec}
                                </p>
                              </li>
                              <li>
                                <span>Weight of Fulfilled Sheets</span>
                                <p>
                                  {acceptedSolution.solution?.summary.total_fulfillment_weight.toFixed(
                                    3
                                  )}{" "}
                                  {acceptedSolution.solution?.summary?.units &&
                                  acceptedSolution.solution?.summary?.units
                                    ?.total_fulfillment_weight
                                    ? capitalize(
                                        weightUnit[
                                          acceptedSolution.solution.summary
                                            .units.total_fulfillment_weight
                                        ].displayName
                                      )
                                    : "T"}
                                </p>
                              </li>
                            </ul>
                          </Col>
                          <Col span={12}>
                            <ul>
                              <li>
                                <span>Cutter</span>
                                <p>
                                  {
                                    jobCard.jobcard.group.machines[0]
                                      .cutter_name
                                  }
                                </p>
                              </li>
                              <li>
                                <span>Edge Trim ( Left / Right)</span>
                                <p>
                                  {
                                    jobCard.jobcard.group.machines[0]
                                      .left_edge_trim
                                  }{" "}
                                  {jobCard.jobcard.group.machines[0]?.units &&
                                  jobCard.jobcard.group.machines[0]?.units
                                    ?.left_edge_trim
                                    ? lengthUnit[
                                        jobCard.jobcard.group.machines[0].units
                                          .left_edge_trim
                                      ].displayName.toUpperCase()
                                    : "CM"}{" "}
                                  /{" "}
                                  {
                                    jobCard.jobcard.group.machines[0]
                                      .right_edge_trim
                                  }{" "}
                                  {jobCard.jobcard.group.machines[0]?.units &&
                                  jobCard.jobcard.group.machines[0]?.units
                                    ?.right_edge_trim
                                    ? lengthUnit[
                                        jobCard.jobcard.group.machines[0].units
                                          .right_edge_trim
                                      ].displayName.toUpperCase()
                                    : "CM"}
                                </p>
                              </li>
                              <li>
                                <span>Number Of Unique Sets</span>
                                <p>
                                  {acceptedSolution && acceptedSolution.solution
                                    ? acceptedSolution?.solution?.summary
                                        .total_unique_patterns
                                    : ""}
                                </p>
                              </li>
                              <li>
                                <span>Weight of Priority Sheets</span>
                                <p>
                                  {acceptedSolution && acceptedSolution.solution
                                    ? acceptedSolution?.solution?.summary
                                        .fulfillment_priority_fulfillment_weight
                                      ? acceptedSolution?.solution?.summary.fulfillment_priority_fulfillment_weight.toFixed(
                                          3
                                        ) +
                                        " " +
                                        (acceptedSolution?.solution?.summary
                                          ?.units &&
                                        acceptedSolution?.solution?.summary
                                          ?.units
                                          ?.fulfillment_priority_fulfillment_weight
                                          ? capitalize(
                                              weightUnit[
                                                acceptedSolution.solution
                                                  .summary.units
                                                  .fulfillment_priority_fulfillment_weight
                                              ].displayName
                                            )
                                          : "T")
                                      : "0"
                                    : "0"}
                                </p>
                              </li>
                            </ul>
                          </Col>
                        </Row>
                        {jobCard.jobcard.group.merged && (
                          <div className="alertmsd">
                            <h4>Merge Orders</h4>
                            <AlertContainer
                              color="blue"
                              icon={alertBlue}
                              msg="This Jobcard has merged orders"
                            />
                          </div>
                        )}
                        {jobCard.state == "rejected" && (
                          <div className="alertmsd">
                            <h4>Approver Remarks</h4>
                            <AlertContainer
                              color="red"
                              icon={alertRed}
                              msg={
                                jobCard.comments.length
                                  ? jobCard.comments
                                  : `Approver remarks does not have any data`
                              }
                            />
                          </div>
                        )}
                      </div>
                    </Panes>
                    {(jobCard?.state === "in_production" ||
                      jobCard?.state === "complete" ||
                      jobCard?.state === "hold") && (
                      <Panes tab="Map Jumbo Reels" key="5">
                        <HaberForm className="mapped-col">
                          <Form name="basic" autoComplete="off">
                            <Row gutter={10} span={24}>
                              <Col
                                span={
                                  jobCard.jobcard.group.machines[0]
                                    .machine_type !== "cutter"
                                    ? 6
                                    : 8
                                }
                              >
                                <Form.Item
                                  name="leftTrim"
                                  label="Left Edge Trim"
                                  initialValue={jobCard.jobcard.group.machines[0].left_edge_trim.toFixed(
                                    2
                                  )}
                                  className="dBlock"
                                >
                                  <Input
                                    disabled
                                    suffix={
                                      jobCard.jobcard.group.machines[0]
                                        ?.units &&
                                      jobCard.jobcard.group.machines[0]?.units
                                        .left_edge_trim
                                        ? lengthUnit[
                                            jobCard.jobcard.group.machines[0]
                                              ?.units.left_edge_trim
                                          ]?.displayName?.toUpperCase()
                                        : "CM"
                                    }
                                  />
                                </Form.Item>
                              </Col>
                              <Col
                                span={
                                  jobCard.jobcard.group.machines[0]
                                    .machine_type !== "cutter"
                                    ? 6
                                    : 8
                                }
                              >
                                <Form.Item
                                  name="rightTrim"
                                  label="Right Edge Trim"
                                  initialValue={jobCard.jobcard.group.machines[0].right_edge_trim.toFixed(
                                    2
                                  )}
                                  className="dBlock"
                                >
                                  <Input
                                    disabled
                                    suffix={
                                      jobCard.jobcard.group.machines[0]
                                        ?.units &&
                                      jobCard.jobcard.group.machines[0]?.units
                                        .right_edge_trim
                                        ? lengthUnit[
                                            jobCard.jobcard.group.machines[0]
                                              ?.units.right_edge_trim
                                          ]?.displayName?.toUpperCase()
                                        : "CM"
                                    }
                                  />
                                </Form.Item>
                              </Col>
                              <Col
                                span={
                                  jobCard.jobcard.group.machines[0]
                                    .machine_type !== "cutter"
                                    ? 6
                                    : 8
                                }
                              >
                                <Form.Item
                                  name="decklewWidth"
                                  label={
                                    jobCard.jobcard.group.grouping_params
                                      .core_id &&
                                    jobCard.jobcard.group.grouping_params
                                      .reel_od &&
                                    jobCard.jobcard.group.machines[0]
                                      .machine_type !== "cutter"
                                      ? "Deckle Width"
                                      : "Maximum Deckle Width"
                                  }
                                  initialValue={
                                    jobCard.jobcard.group.machines[0]
                                      .machine_type !== "cutter"
                                      ? (
                                          jobCard.jobcard.group.machines[0]
                                            .deckle_size_ub +
                                          jobCard.jobcard.group.machines[0]
                                            .left_edge_trim +
                                          jobCard.jobcard.group.machines[0]
                                            .right_edge_trim
                                        ).toFixed(2)
                                      : (
                                          jobCard.jobcard.group.machines[0]
                                            .deckle_length_ub +
                                          (jobCard.jobcard.group.machines[0]
                                            .left_edge_trim +
                                            jobCard.jobcard.group.machines[0]
                                              .right_edge_trim) *
                                            CoversionFactorUnitsToCM[
                                              jobCard?.jobcard?.group
                                                ?.machines[0]?.units
                                                ?.right_edge_trim
                                            ] *
                                            CoversionFactorCMToUnits[
                                              jobCard?.jobcard?.group
                                                ?.machines[0]?.units
                                                ?.deckle_length_ub
                                            ]
                                        ).toFixed(2)
                                  }
                                  className="dBlock"
                                >
                                  <Input
                                    disabled
                                    suffix={
                                      jobCard.jobcard.group.machines[0].units &&
                                      jobCard.jobcard.group.machines[0].units
                                        .deckle_length_ub
                                        ? lengthUnit[
                                            jobCard.jobcard.group.machines[0]
                                              .units.deckle_length_ub
                                          ]?.displayName?.toUpperCase()
                                        : "CM"
                                    }
                                  />
                                </Form.Item>
                              </Col>
                              {jobCard.jobcard.group.grouping_params.core_id &&
                              jobCard.jobcard.group.grouping_params.reel_od &&
                              jobCard.jobcard.group.machines[0].machine_type !==
                                "cutter" ? (
                                <Col span={6}>
                                  <Form.Item
                                    name="CoreOD/ReelOD"
                                    label="Core OD / Reel OD"
                                    initialValue={`${jobCard.jobcard.group.grouping_params.core_id} / ${jobCard.jobcard.group.grouping_params.reel_od}`}
                                    className="dBlock"
                                  >
                                    <Input
                                      disabled
                                      suffix={
                                        jobCard.jobcard.group.grouping_params
                                          .units &&
                                        jobCard.jobcard.group.grouping_params
                                          .units.reel_od
                                          ? lengthUnit[
                                              jobCard.jobcard.group
                                                .grouping_params.units.reel_od
                                            ]?.displayName.toUpperCase()
                                          : "CM"
                                      }
                                    />
                                  </Form.Item>
                                </Col>
                              ) : null}
                            </Row>
                          </Form>
                        </HaberForm>
                        <TableLayoutData>
                          <div
                            className="tableDataFormat "
                            style={{ marginTop: "25px" }}
                          >
                            <Table
                              columns={
                                jobCard.jobcard.group.machines[0]
                                  .machine_type !== "cutter"
                                  ? mapJumboReelColumns.filter(
                                      (item) => item.dataIndex !== "chop_size"
                                    )
                                  : mapJumboReelColumns
                              }
                              dataSource={jumboReelData}
                              onChange={onChange}
                              scroll={{ x: window.screen.width < 1500 && 1150 }}
                              pagination={{
                                total: jumboReelData ? jumboReelData.length : 0,
                                showTitle: false,
                                showTotal: (total, range) =>
                                  `Showing ${range[0]}-${range[1]} of ${total} results`,
                                  pageSizeOptions: [10, 20, 50, 100],
                                  current: currentPage,
                                  pageSize: pageSize,
                                  showSizeChanger: true,
                              }}
                            />
                          </div>
                        </TableLayoutData>
                      </Panes>
                    )}
                    <Panes
                      tab={
                        <span>
                          Size Fulfilment
                          {activeTab == "2" && (
                            <Button
                              key="1"
                              style={{ border: "none" }}
                              onClick={(e) => setSizeExpanded(!sizeExpanded)}
                            >
                              <Iconmoon
                                icon={
                                  sizeExpanded
                                    ? "contract_arrow"
                                    : "expand_arrow"
                                }
                                size={14}
                                color="#EA4E2C"
                              />
                            </Button>
                          )}
                        </span>
                      }
                      key="2"
                    >
                      <TableLayoutData>
                        <div
                          className="tableDataFormat  "
                          style={{ marginTop: "25px" }}
                        >
                          <Table
                            columns={sizeFulfillmentColumnsHead}
                            // dataSource={sizeFulfillmentDetailsList?.filter(
                            //   (order) => order.fulflilledWeight.split(" ")[0] > 0
                            // )}

                            dataSource={sizeFulfillmentDetailsList}
                            onChange={onChange}
                            scroll={{ x: 1200 }}
                            rowClassName={(record) => record.priority && "true"}
                            pagination={{
                              total: sizeFulfillmentDetailsList?.length,
                              showTitle: false,
                              showTotal: (total, range) =>
                                `Showing ${range[0]}-${range[1]} of ${total} results`,
                              pageSizeOptions: [10, 20, 50, 100],
                              current: currentPage,
                              pageSize: pageSize,
                              showSizeChanger: true,
                            }}
                          />
                        </div>
                      </TableLayoutData>
                    </Panes>
                    <Panes
                      tab={
                        <span>
                          Order Fulfillment
                          {activeTab == "3" && (
                            <Button
                              key="1"
                              style={{ border: "none" }}
                              onClick={(e) => setSizeExpanded(!sizeExpanded)}
                            >
                              <Iconmoon
                                icon={
                                  sizeExpanded
                                    ? "contract_arrow"
                                    : "expand_arrow"
                                }
                                size={14}
                                color="#EA4E2C"
                              />
                            </Button>
                          )}
                        </span>
                      }
                      key="3"
                    >
                      <TableLayoutData>
                        <div
                          className="tableDataFormat  "
                          style={{ marginTop: "25px" }}
                        >
                          <Table
                            columns={orderFulfillmentColumnsHead}
                            dataSource={orderDetailsList}
                            onChange={onChange}
                            scroll={{ x: 1300 }}
                            rowClassName={(record) => record.priority && "true"}
                            pagination={{
                              total: orderDetailsList?.length,
                              showTitle: false,
                              showTotal: (total, range) =>
                                `Showing ${range[0]}-${range[1]} of ${total} results`,
                              pageSizeOptions: [10, 20, 50, 100],
                              current: currentPage,
                              pageSize: pageSize,
                              showSizeChanger: true,
                            }}
                          />
                        </div>
                      </TableLayoutData>
                    </Panes>
                    
                  </Tabs>
                </Col>
              </Row>
            </div>
          </DetailFields>
          {/* approve Modal */}
          <ConfirmationModal
            visible={isVisibleApproveModal}
            icon={warning}
            cancelAction={approveModalClose}
            confirmAction={approveModalConfirm}
            param={jobId}
          >
            <span>Are you sure?</span>
            <p>
              You are about to approve this job card, once approved this job
              card can’t be altered later
            </p>
          </ConfirmationModal>
          <ConfirmationModal
            visible={visible}
            icon={warning}
            cancelAction={closeModal}
            confirmAction={modalConfirm}
          >
            <span>Are you sure ?</span>
            <p>
              You are about to start production for this job card, are you sure
              you want to continue?
            </p>
          </ConfirmationModal>

          <ConfirmationModal
            visible={visibleHold}
            icon={warning}
            cancelAction={holdModalClose}
            confirmAction={holdModalConfirm}
          >
            <span>Hold production?</span>
            <p>
              The production for this job card will be put on hold. You cannot
              make any changes to the mapping and cannot print rewinding
              details. Are you sure you want to continue?
            </p>
          </ConfirmationModal>
          {/* <ConfirmationModal
          visible={visibleStartProduction}
          icon={warning}
          cancelAction={closeStartProductionModal}
          confirmAction={startProductionModalConfirm}
          param={jobId}
        >
          <span>Start production ?</span>
          <p>
            The job card will move to the production. Are you sure you want to
            proceed?
          </p>
        </ConfirmationModal> */}

          {/* <ConfirmationModal
          visible={visibleCancelProduction}
          icon={warning}
          cancelAction={closeCancelProductionModal}
          confirmAction={cancelProductionModalConfirm}
          param={jobId}
        >
          <span>Are you sure?</span>
          <p>
            You are about to cancel the production for this jobcard, are you
            sure you want to continue?
          </p>
        </ConfirmationModal> */}

          {/* <ConfirmationModal
          visible={visibleMarkCompletedModal}
          icon={warning}
          cancelAction={closeMarkCompletedModal}
          confirmAction={markCompletedModalConfirm}
          param={jobId}
        >
          <span>Are you sure?</span>
          <p>
            You are about to mark this job as completed, are you sure you want
            to continue?
          </p>
        </ConfirmationModal> */}
          <CancelJobCardDrawer
            jobId={jobId}
            visible={viewCancelJobCardDrawer}
            onClose={closeCancelJobCardDrawer}
            setActionResponse={setActionResponse}
            showToaster={showToaster}
            reFetch={setReFetch}
            jobcardType={jobcardType}
            onCancelSuccess={onCancelSuccess}
            // jobcardType={jobcardType}
            tabNo={activeTab}
            jobcardCode={jobcardCode}
          />

          <CancelProductionDrawer
            jobId={jobId}
            parentReelId={selectedParentReel}
            visible={viewCancelProductionDrawer}
            onCloseCancelProduction={closeCancelProduction}
            onBackCancel={onCloseCancelBack}
            showToaster={showToaster}
            setActionResponse={setActionResponse}
            reFetch={setReFetchJumboReels}
            jobcardType={jobcardType}
            tabNo={activeTab}
            jobcardCode={jobcardCode}
          />

          {viewParentReelJobCardDrawer && (
            <ParentReelJobCardDrawer
              parentReelId={selectedParentReel}
              visible={viewParentReelJobCardDrawer}
              onCloseParentReelCancel={onCloseParentReelCancel}
              onClose={closeParentReelJobCard}
              jobcardType={jobcardType}
              tabNo={activeTab}
              pageType={"deckle"}
              jobCardPly={jobCard.ply}
            />
          )}

          {viewCloseProductionDrawer && (
            <ClosedProductionDrawer
              jobId={jobId}
              parentReelId={selectedParentReel}
              visible={viewCloseProductionDrawer}
              onCloseProduction={closeProduction}
              setActionResponse={setActionResponse}
              showToaster={showToaster}
              reFetch={setReFetchJumboReels}
              jobcardType={jobcardType}
              tabNo={activeTab}
            />
          )}

          {viewMapToReelDrawer && (
            <MapToJumboDrawer
              jobId={jobId}
              parentReelId={selectedParentReel}
              visible={viewMapToReelDrawer}
              onCloseMapToReel={closeMapToReel}
              setActionResponse={setActionResponse}
              showToaster={showToaster}
              reFetch={setReFetchJumboReels}
              type={actionType}
              jobcardType={jobcardType}
              tabNo={activeTab}
              jobCardPly={jobCard.ply}
            />
          )}
          <JobCardRejectDrawer
            visible={visibleRejectDrawer}
            onClose={closeRejectDrawer}
            onCloseGrade={closeRejectDrawer}
            jobId={jobId}
            setReFetch={setReFetch}
            setActionResponse={setActionResponse}
            showToaster={showToaster}
            jobcardCode={jobcardCode}
          />

          {toaster && actionResponse.msg && (
            <AlertContainer
              color={`${actionResponse.error ? "red" : "green"} toaster`}
              icon={actionResponse.error ? alertRed : alertGreen}
              msg={capitalize(actionResponse.msg)}
            />
          )}

          <ViewDeckleOrder
            selectedOrderNo={selectedOrderNo}
            // showButton={true}
            visible={viewOrder}
            onClose={closeViewDrawer}
            onCloseGrade={closeViewDrawer}
            category={selectedOrder?.category}
          />
        </ResultWrap>
      </RightLayoutContainer>
    )
  ) : (
    <RightLayoutContainer>
      {/* {console.log("Jobcard", jobCard)} */}
      <PageTitleComp className="marginRightAdg" style={{ borderBottom: "0px" }}>
        <PageHeader
          ghost={false}
          // onBack={() => navigate("../job-cards")}
          onBack={() => navigate(-2)}
          title="Job Card Details"
        ></PageHeader>
      </PageTitleComp>
      <ResultWrap>
        <DetailFields
          className="jobCardView"
          style={{ justifyContent: "flex-start" }}
        >
          <PageTitleComp style={{ borderBottom: "0" }}>
            <PageHeader
              ghost={false}
              // title={`Job Card ${jobCard.id}`}
              className="jobCardList-Grid"
            ></PageHeader>

            <div
              className={`jobCardList ${"fullWidth"}`}
              style={{
                alignSelf: "center",
                display: "flex",
                marginTop: "34px",
                // alignContent:'top'
              }}
            >
              {/* <JobCardColorStatus>
                <div className="statusVal" dataval={jobCard.state}>
                  {jobcardState(jobCard.state)}
                </div>
              </JobCardColorStatus> */}
            </div>
            {activeTab >= 2 && (
              <Col span={9} style={{ display: "absolute" }}>
                <div
                  className="cancelledSetMessage"
                  style={{
                    display: "flex",
                    justifyContent: "center", // Center content horizontally
                    alignItems: "center", // Center content vertically
                    marginTop: "25px",
                    borderRadius: "4px",
                    backgroundColor: "#f4f0ec",
                    padding: "4px 6px",
                    opacity: 0.95,
                  }}
                >
                  {/* <div className="centerAlignMeVertically" style={{ padding: "2px 6px 0px 3px" }}>
    <Iconmoon icon="warning_new" size={20} style={{ color: "#808080" }} />
  </div>
  <span style={{ fontSize: "14px", color: "#555555" }}>
    A few sets were cancelled in this job card. Hence, fulfilled
    quantity might not be accurate for the cancelled sets.
  </span> */}
                </div>
              </Col>
            )}
          </PageTitleComp>

          <div className="MatchResult JobResulted">
            <Row span={24}>
              <Col
                span={15}
                className="pipeBlock"
                style={{
                  paddingRight: "20px",
                  transform: activeTab >= 2 ? "translateY(-14px)" : "",
                }}
              >
                <div
                  style={{
                    paddingTop: "50px",
                    paddingBottom: "50px",
                  }}
                >
                  <CardShimmerStyle>
                    <div
                      style={{
                        display: "block",
                        marginLeft: "auto",
                        marginRight: "auto",
                        opacity: "70%",
                        width: "341.62px",
                        marginTop: "60px",
                      }}
                    >
                      <Skeleton.Image
                        active={true}
                        style={{
                          width: "105px",
                          marginLeft: "auto",
                          marginRight: "auto",
                        }}
                      />
                    </div>
                  </CardShimmerStyle>
                  {/* <div 
            style={{
                fontFamily: "var(--sf-pro-display-m)",
                fontWeight: "500",
                fontSize: "14px",
                height: "16px",
                color: "#A19F9D",
                paddingTop: "20px",
                display: "block",
                marginLeft: "auto",
                marginRight: "auto",
                width: "150px",
                textAlign: "center",
           }}
           >{heading}
            </div> */}
                  <div
                    style={{
                      paddingTop: "30px",
                      fontFamily: "var(--sf-pro-display-m)",
                      fontWeight: "400",
                      fontSize: "12px",
                      height: "20px",
                      color: "#A19F9D",
                      display: "block",
                      marginLeft: "auto",
                      marginRight: "auto",
                      width: "311px",
                      textAlign: "center",
                    }}
                  >
                    {"Fetching jobcard details"}
                  </div>
                </div>
              </Col>
              <Col span={9} className="colLayoutBlock leftPostTab">
                <Tabs
                  defaultActiveKey="1"
                  activeKey={activeTab}
                  onChange={tabChange}
                  className="topPostTab innerPostTab"
                >
                  <Panes tab="Summary" key="1">
                    <div className="lossValue">
                      <Row span={24} style={{ paddingTop: "10px" }}>
                        <Col span={12}>
                          <div
                            className={"summaryValue"}
                            style={{ padding: "0px" }}
                          >
                            <CardShimmerStyle>
                              <div style={{ width: "100%", display: "flex" }}>
                                <div
                                  style={{
                                    flexDirection: "row",
                                    display: "flex",
                                    width: "100%",
                                  }}
                                >
                                  <Skeleton.Button
                                    active={true}
                                    style={{ height: "100px" }}
                                  ></Skeleton.Button>
                                </div>
                              </div>
                            </CardShimmerStyle>
                          </div>
                        </Col>
                        <Col span={12}>
                          <div
                            className={"summaryValue"}
                            style={{ padding: "0px" }}
                          >
                            <CardShimmerStyle>
                              <div style={{ width: "100%", display: "flex" }}>
                                <div
                                  style={{
                                    flexDirection: "row",
                                    display: "flex",
                                    width: "100%",
                                  }}
                                >
                                  <Skeleton.Button
                                    active={true}
                                    style={{ height: "100px" }}
                                  ></Skeleton.Button>
                                </div>
                              </div>
                            </CardShimmerStyle>
                          </div>
                        </Col>
                      </Row>

                      <Row span={24} style={{ paddingTop: "10px" }}>
                        <Col span={12}>
                          <div
                            className={"summaryValue"}
                            style={{ padding: "0px" }}
                          >
                            <CardShimmerStyle>
                              <div style={{ width: "100%", display: "flex" }}>
                                <div
                                  style={{
                                    flexDirection: "row",
                                    display: "flex",
                                    width: "100%",
                                  }}
                                >
                                  <Skeleton.Button
                                    active={true}
                                    style={{ height: "100px" }}
                                  ></Skeleton.Button>
                                </div>
                              </div>
                            </CardShimmerStyle>
                          </div>
                        </Col>
                        <Col span={12}>
                          <div
                            className={"summaryValue"}
                            style={{ padding: "0px" }}
                          >
                            <CardShimmerStyle>
                              <div style={{ width: "100%", display: "flex" }}>
                                <div
                                  style={{
                                    flexDirection: "row",
                                    display: "flex",
                                    width: "100%",
                                  }}
                                >
                                  <Skeleton.Button
                                    active={true}
                                    style={{ height: "100px" }}
                                  ></Skeleton.Button>
                                </div>
                              </div>
                            </CardShimmerStyle>
                          </div>
                        </Col>
                      </Row>

                      <Row span={24} style={{ paddingTop: "10px" }}>
                        <Col span={12}>
                          <div
                            className={"summaryValue"}
                            style={{ padding: "0px" }}
                          >
                            <CardShimmerStyle>
                              <div style={{ width: "100%", display: "flex" }}>
                                <div
                                  style={{
                                    flexDirection: "row",
                                    display: "flex",
                                    width: "100%",
                                  }}
                                >
                                  <Skeleton.Button
                                    active={true}
                                    style={{ height: "60px" }}
                                  ></Skeleton.Button>
                                </div>
                              </div>
                            </CardShimmerStyle>
                          </div>
                        </Col>
                        <Col span={12}>
                          <div
                            className={"summaryValue"}
                            style={{ padding: "0px" }}
                          >
                            <CardShimmerStyle>
                              <div style={{ width: "100%", display: "flex" }}>
                                <div
                                  style={{
                                    flexDirection: "row",
                                    display: "flex",
                                    width: "100%",
                                  }}
                                >
                                  <Skeleton.Button
                                    active={true}
                                    style={{ height: "60px" }}
                                  ></Skeleton.Button>
                                </div>
                              </div>
                            </CardShimmerStyle>
                          </div>
                        </Col>
                      </Row>
                      <Row span={24} style={{ paddingTop: "10px" }}>
                        <Col span={12}>
                          <div
                            className={"summaryValue"}
                            style={{ padding: "0px", backgroundColor: "white" }}
                          >
                            <CardShimmerStyle>
                              <div style={{ width: "70%", display: "flex" }}>
                                <div
                                  style={{
                                    flexDirection: "row",
                                    display: "flex",
                                    width: "100%",
                                  }}
                                >
                                  <Skeleton.Button
                                    active={true}
                                    style={{ height: "20px" }}
                                  ></Skeleton.Button>
                                </div>
                              </div>
                            </CardShimmerStyle>
                          </div>
                        </Col>
                        <Col span={12}>
                          <div
                            className={"summaryValue"}
                            style={{ padding: "0px", backgroundColor: "white" }}
                          >
                            <CardShimmerStyle>
                              <div style={{ width: "70%", display: "flex" }}>
                                <div
                                  style={{
                                    flexDirection: "row",
                                    display: "flex",
                                    width: "100%",
                                  }}
                                >
                                  <Skeleton.Button
                                    active={true}
                                    style={{ height: "20px" }}
                                  ></Skeleton.Button>
                                </div>
                              </div>
                            </CardShimmerStyle>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Panes>
                  <Panes tab="Size Fulfilment" key="2">
                    {/* { acceptedSolution.solution.data.parent_reel_cancelled ? <AlertContainer
                      color="blue"
                      icon={warningjob}
                      msg="A few sets were cancelled in this job card. Hence, fulfilled quantity might not be accurate for the cancelled sizes."
                      removeBottomMargin={true}
                      jobCard = {true}
                    /> : ''} */}
                    <TableLayoutData>
                      <div
                        className="tableDataFormat  "
                        style={{ marginTop: "25px" }}
                      >
                        <TableShimmer
                          header={sizeFulfillmentColumnsHead}
                          scroll={1300}
                        />
                      </div>
                    </TableLayoutData>
                  </Panes>
                  <Panes tab="Order Fulfillment" key="3">
                    <TableLayoutData>
                      <div
                        className="tableDataFormat  "
                        style={{ marginTop: "25px" }}
                      >
                        <TableShimmer header={orderFulfillmentColumnsHead} scroll={1600} />
                      </div>
                    </TableLayoutData>
                  </Panes>
                  
                </Tabs>
              </Col>
            </Row>
          </div>
        </DetailFields>
        {/* approve Modal */}
      </ResultWrap>
    </RightLayoutContainer>
  );
};
export default SheetJobCardDetailData;
